/**
 * NÚT ĐIỂM THƯỞNG BLOY — eGURU 08/09/2026
 *
 * Ba việc, đều là thứ app không tự làm được:
 *   1. Gắn/gỡ lớp `bloy-dang-mo` trên <html> để CSS đổi logo "d" thành dấu X.
 *   2. Trả chữ về TIẾNG ANH khi khách đang xem bản tiếng Anh của website.
 *   3. (15/09) Ghi đè TIẾNG VIỆT cho 15 khoá app không có ô admin — xem GHI_DE_VI.
 *   5. (18/09) CHỈ HIỆN GIỚI THIỆU BẠN BÈ khi <body> có lớp eguru-chi-refer; 14:13 thêm eguru-an-refer = ngược lại, giữ hộp, BỎ khối giới thiệu (mặc định) — xem chiRefer()/doiTenNut().
 *   4. (16/09) GIẤU THƯỞNG MẶC ĐỊNH CỦA REFERRAL (mã 15%) + thay "300 điểm" bằng 2 dòng quà người giới thiệu — xem DOI_CHU + giauThuong() + MOC_BAN_NHAN.
 *      Chương trình Giới thiệu bạn bè của Derma thưởng QUÀ THẬT qua Shopify Flow, không dùng
 *      điểm/mã; panel Refer a friend của BLOY lại không lưu được (lỗi delayDays) nên chưa hạ
 *      300 điểm / 15% về 0. Anh Thắng gật 16/09 16:31 (qua website-theme): đổi chữ widget cho
 *      khớp chương trình và giấu khối mã. Đây là lớp THEME (dev) — chữ trong BLOY admin đổi
 *      sau khi BLOY sửa lỗi lưu; SPEC-GIOI-THIEU-GIAU-THUONG-BLOY-16-09.md ở gốc Code_theme.
 *
 * ================== VÌ SAO PHẢI TỰ DỊCH NGƯỢC ==================
 * App BLOY có sẵn cơ chế đa ngữ (Settings → Multiple-language translation)
 * nhưng danh sách 24 thứ tiếng KHÔNG CÓ TIẾNG VIỆT. Nên tiếng Việt buộc phải
 * gõ vào bộ chữ GỐC ở thẻ Content — tức mọi khách đều thấy tiếng Việt, kể cả
 * khi bấm sang bản tiếng Anh. Cơ chế của app lại đổi theo MARKET chứ không
 * theo ngôn ngữ, mà cửa hàng chỉ có một market Việt Nam, nên cũng không nhờ
 * được nó.
 *
 * Lối duy nhất còn lại: iframe của popup CÙNG GỐC với trang, nên đọc ghi được
 * chữ bên trong. Trang tiếng Anh thì tráo 42 chuỗi ngược về tiếng Anh.
 *
 * ================== KHI SỬA CHỮ THÌ SỬA CẢ HAI NƠI ==================
 * Bảng dưới đây phải khớp từng chữ với thẻ Content trong app BLOY
 * (Branding → Loyalty popup → Content). Sửa một nơi mà quên nơi kia thì câu đó
 * đơn giản là không được tráo, trang tiếng Anh sẽ hiện tiếng Việt.
 *
 * Câu nào có {{...}} thì trong bảng ghi bằng dấu {0}: lúc chạy sẽ chụp lại
 * phần app điền vào rồi đặt y nguyên sang câu tiếng Anh. Thứ tự {0}, {1} ở hai
 * vế PHẢI như nhau.
 *
 * Widget chỉ chạy ở trang bán lẻ; cổng đại lý ẩn cả `.BLOY-root`
 * (xem assets/portal.css), lúc đó không tìm thấy gì và tự ngồi im.
 */
(function () {
  'use strict';

  var LOP = 'bloy-dang-mo';

  /* [tiếng Việt, tiếng Anh] — {0}/{1} là chỗ app điền số/ngày vào.
     15/09/2026: 43 → 173 cặp. Nguồn: website-theme điền tiếng Việt vào đủ 325 ô Settings ›
     Multiple-language translation của BLOY (SPEC-BLOY-BANG-VI-EN-15-09.md/.json ở gốc Code_theme).
     SỬA CHỮ TRONG APP THÌ SỬA Ở ĐÂY — lệch là /en lòi tiếng Việt; chuông báo ở keuThieu() bên dưới.
     Cặp cuối "Điểm thưởng" là chữ trên chính cái nút góc dưới trái (ô "Widget icon" trong app). */
  var BANG = [
    ['điểm', 'points'],
    ['Đăng ký tài khoản', 'Sign up'],
    ['Mua hàng', 'Make a purchase'],
    ['Voucher giảm giá', 'Discount voucher'],
    ['Giảm giá theo phần trăm', 'Percentage discount'],
    ['Miễn phí vận chuyển', 'Free shipping'],
    ['Thu hồi điểm do đơn hàng bị huỷ hoặc hoàn tiền', 'Points withdrawal due to order canceled or refunded'],
    ['Thu hồi điểm do đơn hàng được hoàn tiền', 'Points withdrawal due to order refunded'],
    ['Thu hồi điểm do đơn hàng bị huỷ', 'Points withdrawal due to order canceled'],
    ['Thành viên', 'Standard'],
    ['Điểm thưởng', 'Reward'],
    ['Chào mừng đến với', 'Welcome to'],
    ['Chương trình tích điểm', 'Points program'],
    ['Bạn đang có', 'You have'],
    ['Chi tiêu VIP của bạn là', 'Your VIP spending is'],
    ['Trở thành thành viên', 'Become a member'],
    /* Nút tham gia (post-purchase + LTO) — có trong bảng 43 cũ, JSON 15/09 sót; không dấu nên chuông keuThieu không bắt. */
    ['Tham gia ngay', 'Join now'],
    ['Tham gia chương trình tích điểm để nhận những ưu đãi dành riêng cho thành viên', 'Join the points program to start earning for exclusive rewards'],
    ['Đã có tài khoản?', 'Already have an account?'],
    ['Đăng nhập', 'Sign in'],
    ['Cách tích điểm', 'Earn points'],
    ['Đổi ưu đãi', 'Redeem points'],
    ['Giới thiệu bạn bè', 'Refer a friend'],
    ['Quà cảm ơn hoặc voucher cho bạn, bộ dùng thử cho bạn của bạn', 'Referral: a thank-you gift or voucher for you, a trial kit for your friend'],   // 28/09 dòng rule referral trong Cách tích điểm (luật hiện hành)
    /* 16/09 — chữ referral mới (DOI_CHU bên dưới), phải có cặp EN kẻo /en lòi tiếng Việt */
    ['Giới thiệu bạn bè mua Dermalogica lần đầu — bạn của bạn nhận bộ quà, bạn nhận quà mini-size khi đơn hoàn tất', 'Introduce a friend to their first Dermalogica order — they receive a gift set, you receive a mini-size gift once the order is complete'],
    ['Đơn đầu từ 1,5 triệu: Bộ dùng thử các bước nền tảng · từ 2,5 triệu: thêm Phiếu quy đổi Dịch Vụ Tăng Cường', 'First order from 1.5M₫: the Foundation Trial Kit · from 2.5M₫: plus a Professional Treatment Enhancement voucher'],
    /* 28/09/2026 — luật giới thiệu hiện hành: lượt 1–2 quà Special Cleansing Gel 15ml, từ lượt 3 MỖI lượt một voucher 20%. */
    ['Lượt 1–2: 01 Special Cleansing Gel 15ml, gửi khi đơn của bạn bè giao xong', 'Referrals 1–2: a Special Cleansing Gel 15ml, sent once your friend\'s order is delivered'],
    ['Từ lượt 3: mỗi lượt một voucher dịch vụ 20% tiền hàng đơn đó', 'From referral 3: a service voucher worth 20% of that order, for every referral'],
    ['Mã voucher của bạn: {0}', 'Your voucher code: {0}'],
    ['Đăng ký nhận quà', 'Sign up for your gift'],
    /* 16/09 22:40 — UI widget: mô tả rút ngắn + 2 dòng mốc tách riêng (chiaMoc) */
    ['Giới thiệu bạn mua Dermalogica lần đầu — cả hai cùng nhận quà.', 'Introduce a friend to their first Dermalogica order — you both receive a gift.'],
    ['Đơn đầu từ 1,5 triệu: Bộ dùng thử các bước nền tảng', 'First order from 1.5M₫: the Foundation Trial Kit'],
    /* 17/09 09:45 — popup B (SPEC-GIOI-THIEU-UI-KHOA-3): 2 dòng "Đơn đầu tiên" + dòng đủ 3 lượt của widget.
       10:59 anh Thắng: mốc 2,5 triệu phải ghi "bộ 5 + voucher" kẻo hiểu là chỉ có voucher.
       13:32 anh Thắng: bỏ "(dùng tại salon)" — website không nhắc chữ salon (Brand Guidelines). */
    ['Đơn đầu tiên từ 1,5 triệu: Bộ dùng thử các bước nền tảng', 'Your first order from 1.5M₫: the Foundation Trial Kit'],
    ['Đơn đầu tiên từ 2,5 triệu: Bộ dùng thử các bước nền tảng + Phiếu quy đổi Dịch Vụ Tăng Cường', 'Your first order from 2.5M₫: the Foundation Trial Kit + a Professional Treatment Enhancement voucher'],
    /* 25/09 18:20 — cặp EN cho 2 câu đủ-3-lượt đang chạy (CHU_DU_3 / CHU_DU_3_CO_MA, xem phần dưới):
       trước nay BANG không có nên /en lòi tiếng Việt. Cặp cũ "Dermalogica sẽ liên hệ…" là chữ 17/09,
       Flow D tự cấp mã từ 15:15 hôm đó nên câu ấy không còn được in ra — đã bỏ. EN giữ "treatment voucher"
       theo Brand Guidelines p52 dù bản Việt đã đổi sang "voucher dịch vụ".
       29/09/2026 (kiểm lần 2): bản Việt thống nhất với thư Klaviyo + tài liệu — voucher của A = "voucher liệu trình 20%",
       quà mức 2 của B = "Phiếu quy đổi Dịch Vụ Tăng Cường" (trước ghi "voucher Professional Treatment Enhancement").
       Đổi đồng loạt ở DOI_CHU, MOC, MOC_BAN_NHAN, CHU_DU_3* và vế Việt của BANG; vế EN giữ nguyên. */
    ['Từ lượt 3, mỗi lượt có một voucher dịch vụ 20% — voucher đang được chuẩn bị.', 'From referral 3, each referral earns a 20% service voucher — we\'re preparing it.'],
    ['Từ lượt 3, mỗi lượt có một voucher dịch vụ 20%, gửi qua email của bạn.', 'From referral 3, each referral earns a 20% service voucher, sent to your email.'],
    ['Từ 2,5 triệu: thêm Phiếu quy đổi Dịch Vụ Tăng Cường', 'From 2.5M₫: plus a Professional Treatment Enhancement voucher'],
    ['Bạn có quà từ bạn bè! Nhập email để được ghi nhận — quà gửi kèm đơn đầu tiên:', 'You\'ve got a gift from a friend! Enter your email to be registered — the gift ships with your first order:'],
    ['Bạn có quà từ bạn bè! Nhập email để được ghi nhận — quà gửi kèm đơn đầu tiên: từ 1,5 triệu nhận Bộ dùng thử các bước nền tảng, từ 2,5 triệu thêm Phiếu quy đổi Dịch Vụ Tăng Cường', 'You\'ve got a gift from a friend! Enter your email to be registered — the gift ships with your first order: from 1.5M₫ the Foundation Trial Kit, from 2.5M₫ plus a Professional Treatment Enhancement voucher'],
    ['Đăng ký', 'Sign up'],
    ['Đã ghi nhận! Quà sẽ gửi kèm đơn đầu tiên của bạn', 'Registered! Your gift ships with your first order'],
    ['Đã giới thiệu thành công {0} người', '{0} referrals completed'],
    ['Tặng bạn bè một ưu đãi, và nhận phần của bạn khi họ mua hàng', 'Give your friends a reward and claim your own when they make a purchase'],
    ['Bạn của bạn nhận', 'They get'],
    ['Bạn nhận', 'You get'],
    ['Chương trình VIP', 'VIP Program'],
    ['Tấm vé mở mọi ưu đãi dành riêng cho bạn. Lên hạng cao hơn để nhận thêm quyền lợi', 'Your all access pass to exclusive rewards. Reach higher tiers for more exclusive perks'],
    ['Chi tiêu {0}', 'Spend {0}'],
    ['Tích {0}', 'Earn {0}'],
    ['Đặt {0}', 'Place {0}'],
    ['Chi tiêu VIP của bạn là {0}', 'Your VIP spending is {0}'],
    ['Bạn đang có {0}', 'You have {0}'],
    ['Chi tiêu thêm {0} để lên hạng {1}', 'Spend {0} more to reach {1}'],
    ['Tích thêm {0} để lên hạng {1}', 'Earn {0} more to reach {1}'],
    ['Đặt thêm {0} để lên hạng {1}', 'Place {0} more to reach {1}'],
    ['Chúc mừng! Bạn đang ở hạng cao nhất', 'Congratulations! You\'re in the highest tier'],
    ['Hạng mới sẽ cập nhật sau ngày {0}', 'New tier will be updated after {0}'],
    ['Bạn đủ điều kiện lên hạng {0}.', 'You are eligible for {0} tier.'],
    ['Quyền lợi', 'Perks'],
    ['Ưu đãi khi lên hạng', 'Entry Rewards'],
    ['Hạng hiện tại của bạn', 'Your current tier'],
    ['Sắp có…', 'Coming soon...'],
    ['Quay lại', 'Back'],
    ['Việc tiếp theo', 'Next action'],
    ['Hoạt động của bạn', 'Your activities'],
    ['Tham gia ngay hôm nay để nhân {0} lần điểm cho mọi đơn hàng trong cuối tuần', 'Join the loyalty program today to earn {0}X points on every purchase during weekend'],
    ['Kết thúc ngày {0}', 'Ends on {0}'],
    ['Nhân {0} lần điểm cho mọi đơn hàng bạn đặt trong cuối tuần', 'Earn {0}X points on every purchase you make during weekend'],
    ['Đặt thêm đơn để nhận điểm thưởng và ưu đãi dành riêng', 'Place more orders to earn exclusive rewards and bonus points'],
    ['Chúc mừng bạn đã hoàn thành tất cả các mốc', 'Congratulations on completing all milestones'],
    ['Ưu đãi của bạn', 'Your rewards'],
    ['Quyền lợi dành riêng cho bạn', 'Your exclusive perks'],
    ['Tự động áp dụng khi thanh toán', 'Auto-applied at checkout'],
    ['Hoàn {0} giá trị mọi đơn hàng, tối đa {1}, vào số dư tín dụng', 'Cashback {0} of all orders, maximum {1}, by store credit'],
    ['Hoàn {0} giá trị mọi đơn hàng vào số dư tín dụng', 'Cashback {0} of all orders, by store credit'],
    ['Sao chép', 'Copy'],
    ['Áp dụng', 'Apply'],
    ['Đã dùng', 'Used'],
    ['Đã hết hạn', 'Expired'],
    ['Hạn dùng: {0}', 'Exp: {0}'],
    ['Hết hạn: {0}', 'Expired: {0}'],
    ['Bạn chưa có ưu đãi nào. Hãy tích điểm rồi đổi lấy những ưu đãi hấp dẫn!', 'No rewards yet. Earn points by completing actions and redeem them for exciting rewards!'],
    ['Xem cách tích điểm', 'View ways to earn points'],
    ['Chọn sản phẩm', 'Select product'],
    ['Hoàn thành', 'Complete'],
    ['Cập nhật', 'Update'],
    ['Giới thiệu', 'Refer'],
    ['{0} cho mỗi {1} chi tiêu', '{0} for every {1} spent'],
    ['(+{0} khi kèm ảnh/video)', '(+{0} for media)'],
    ['Giới hạn: {0} lần. Làm mới sau {1} ngày.', 'Limit: {0} times. Renewed after {1} days.'],
    ['Đăng ký nhận tin', 'Subscribe'],
    ['Nhập email chưa từng đăng nhập hay mua hàng trên web, rồi đặt hàng bằng đúng email đó — quà được tính theo email này. Đừng đăng nhập trước khi bấm Đăng ký.', 'Enter an email that has never been used to sign in or order on our site, then order with that same email — the gift is tracked by this email. Don\'t sign in before you tap Sign up.'],   // 18/09 nhắc điều kiện (hộp B)
    ['Đánh giá', 'Review'],
    ['Ưu đãi sinh nhật chỉ nhận một lần mỗi năm. Vui lòng nhập hoặc cập nhật ngày sinh trước sinh nhật ít nhất 30 ngày', 'Birthday rewards can only be claimed once per year. Please enter or update your birthday at least 30 days in advance'],
    ['Chọn ngày', 'Choose date'],
    ['Đã cập nhật ngày sinh', 'Birthday updated'],
    ['Bạn sẽ tự động nhận {0} vào ngày sinh nhật.', 'You’ll automatically receive {0} on your birthday.'],
    ['Đã hiểu', 'Okay'],
    ['Cảm ơn bạn đã đăng ký nhận tin!', 'Thank you for your subscription!'],
    ['Bạn vừa nhận {0} để mở khoá những ưu đãi hấp dẫn phía trước!', 'You’ve earned {0} to unlock exciting rewards ahead!'],
    ['Nhận điểm', 'Claim'],
    ['để bắt đầu theo dõi tiến độ của bạn', 'to start tracking your progress'],
    ['Tiến độ của bạn', 'Your progress'],
    ['Mốc', 'Milestone'],
    ['Đặt {0} đơn hàng để nhận {1}', 'Place {0} orders to earn {1}'],
    ['Mốc tiếp theo', 'Next milestone'],
    ['Mốc đã hoàn thành', 'Completed milestone'],
    ['Đặt thêm {0} đơn hàng để nhận {1}', 'Place {0} more orders to earn {1}'],
    ['Áp dụng cho đơn hàng từ {0}', 'Apply to orders from {0}'],
    ['Áp dụng cho đơn hàng đặt từ {0} đến {1}', 'Apply to orders placed from {0} to {1}'],
    ['Chúc mừng bạn đã nhận {0} khi hoàn thành mốc {1}', 'Congratulations on earning {0} by completing milestone {1}'],
    ['Mua sắm ngay', 'Go shopping'],
    ['Tiếp tục', 'Continue'],
    ['Giảm {0} cho mỗi {1}', 'Discount {0} for every {1}'],
    ['Tín dụng {0} cho mỗi {1}', 'Credit {0} for every {1}'],
    ['Cần {0}', 'Cost {0}'],
    ['Bạn được giảm {0} cho cả đơn hàng khi đổi {1}', 'You will get {0} off your entire order for {1} redeemed'],
    ['Bạn nhận {0} tín dụng khi đổi {1}', 'You will get {0} credit for {1} redeemed'],
    ['Việc đổi ưu đãi đang tạm dừng', 'Ways to redeem is paused temporarily'],
    ['Đã đạt giới hạn đổi ưu đãi', 'Redemption limit reached'],
    ['Bạn đã nhận {0} vào số dư tín dụng', 'You\'ve received {0} in store credit'],
    ['Áp dụng khi thanh toán', 'Apply it at checkout'],
    ['Bạn đã đổi {0} lấy {1}', 'You got a {1} by using {0}'],
    ['Chọn một sản phẩm bên dưới để nhận quà tặng', 'You will receive a free product by selecting a product below'],
    ['Chọn', 'Select'],
    ['Thêm vào giỏ', 'Add to cart'],
    ['Chúc mừng bạn đã nhận {0}. Sản phẩm đã được thêm vào giỏ hàng.', 'Congratulations on receiving a {0}. The product has been added to the cart.'],
    ['Xem giỏ hàng', 'Go to cart'],
    ['Giảm {0}', '{0} off'],
    ['Gửi liên kết này cho bạn bè', 'Send this link to your friend'],
    ['Hoặc gửi qua', 'Or send via'],
    ['Email của bạn bè', 'Your friends\' email'],
    ['Cách nhau bằng dấu phẩy nếu nhiều email', 'Separate each email with a comma'],
    ['Vui lòng nhập email hợp lệ, cách nhau bằng dấu phẩy', 'Please enter valid emails, separated each email with a comma'],
    ['Bạn không thể tự giới thiệu chính mình', 'You cannot refer to yourself'],
    ['Lời nhắn của bạn', 'Your message'],
    ['Đôi lời gửi bạn bè. Chúng tôi sẽ tự thêm liên kết ưu đãi cho bạn :)', 'A personalized message for your friends. We will take care of adding the offer link for you :)'],
    ['Gửi lời mời', 'Send referral invite'],
    ['Đã gửi lời mời thành công!', 'Invite(s) sent successfully!'],
    ['Nhận mã ưu đãi', 'Get your coupon'],
    ['Bạn có một món quà từ bạn bè! Nhập mã này khi thanh toán để nhận ưu đãi', 'You\'ve got a gift from a friend! Apply this code during checkout to enjoy your reward'],
    ['Quà của bạn', 'Your gift'],
    ['Nhập email của bạn', 'Enter your email'],
    ['Bạn không đủ điều kiện nhận quà này', 'You\'re not eligible to receive the gift'],
    ['Nhận mã', 'Claim coupon'],
    ['Mã giảm giá của bạn', 'Your discount code'],
    ['Đã áp dụng giảm giá', 'Discount applied'],
    ['Giới thiệu {0}', 'Refer {0}'],
    ['Chưa có hoạt động nào', 'No activities yet'],
    ['Chưa có hoạt động nào được ghi nhận. Hãy bắt đầu tích điểm để nhận những ưu đãi dành riêng cho thành viên.', 'No activities have been logged in the points program. Start earning points to get access to exclusive rewards.'],
    ['Hoàn thành mốc {0}', 'Complete milestone {0}'],
    ['Gỡ mốc {0} do đơn hàng thay đổi trạng thái', 'Removed milestone {0} due to order status change'],
    ['Thẻ thành viên', 'Loyalty pass'],
    ['Thêm thẻ {0} vào Apple/Google Wallet. Điểm và hạng luôn đi cùng bạn.', 'Add your {0} pass to Apple/Google Wallet. Your points and tier go where you go.'],
    ['Bạn đã nhận {0} khi ghé thăm cửa hàng hôm nay', 'You’ve earned {0} by visiting store today'],
    ['Bạn đã nhận {0} khi hoàn thành chuỗi ngày ghé thăm', 'You’ve earned {0} by completing the streak'],
    ['Chuỗi 7 ngày', '7-day streak'],
    ['Đã hoàn thành chuỗi', 'Streak completed'],
    ['Nhận {0} khi ghé thăm cửa hàng {1} ngày liên tiếp', 'Earn {0} by visiting the store {1} days in a row'],
    ['Đăng nhập để nhận {0} khi ghé thăm cửa hàng {1} ngày liên tiếp', 'Log in to earn {0} by visiting the store {1} days in a row'],
    ['Chúc mừng bạn đã nhận {0} khi hoàn thành chuỗi ngày ghé thăm', 'Congratulations on earning {0} by finishing Streak'],
    ['Bạn sẽ nhận {0} khi mua sản phẩm này', 'You’ll earn {0} for this purchase'],
    ['Bình thường {0} — nay nhận {1} cho sản phẩm này, gấp {2} lần!', 'Normally {0} — earn {1} for this purchase, {2}× the usual reward!'],
    ['Chúc mừng bạn!', 'Congratulations!'],
    ['Bạn đã nhận {0} từ đơn hàng này.', 'You’ve earned {0} with this order.'],
    ['Tiếp tục mua sắm để tích thêm điểm.', 'Continue making purchases to earn more points.'],
    ['Tích thêm điểm', 'Earn more points'],
    ['Tham gia chương trình thành viên để nhận những ưu đãi dành riêng.', 'Join our loyalty program to earn exclusive rewards.'],
    ['Đã là thành viên?', 'Already a member?'],
    ['Bạn đã đặt {0} đơn hàng, đặt thêm {1} đơn để nhận {2}', 'You placed {0} orders, place {1} more orders to earn {2}'],
    ['Chúc mừng bạn đã nhận {0} khi đặt {1} đơn hàng', 'Congratulations on earning {0} by placing {1} orders'],
    ['Hạng hiện tại: {0}', 'Current tier: {0}'],
    ['Hạng đặc biệt', 'Exclusive tier'],
    ['Bạn đang ở hạng đặc biệt', 'You are in an exclusive tier'],
    ['Bạn đang có {0}, đặt đơn này để nhận thêm {1}!', 'You have {0}, place this order to earn {1} more!'],
    ['Bạn đang có {0}. Việc tích điểm cho đơn hàng đang tạm dừng', 'You have {0}. Earning points for orders is paused temporarily'],
    ['Ưu đãi', 'Rewards'],
    ['Đăng nhập để đổi điểm lấy ưu đãi', 'Log in to redeem points for rewards'],
    ['Tự động áp dụng', 'Auto-applied'],
    ['Chưa có ưu đãi nào', 'No rewards yet'],
    ['Đổi', 'Redeem'],
    ['Sao chép hoặc áp dụng mã giảm giá vào giỏ hàng. Nếu chưa dùng ngay, bạn có thể xem lại mã trong mục Ưu đãi của bạn.', 'Copy or apply the discount code to your cart. If you do not use this code now, you can always access it later in Your Rewards tab.'],
    ['Số dư tín dụng sẽ tự hiện ở bước thanh toán. Bạn chỉ cần chọn có áp dụng cho đơn hàng hay không.', 'Available store credit is automatically shown at checkout. Simply choose whether to apply it to your order.'],
    ['Sản phẩm đã được thêm vào giỏ hàng. Nếu chưa dùng ưu đãi ngay, bạn có thể xem lại trong mục Ưu đãi của bạn.', 'The product has been added to the cart. If you do not use the discount now, you can always access it later in Your Rewards tab.'],
    ['Bạn đã đạt giới hạn đổi của ưu đãi này', 'You have reached the redemption limit for this reward'],
    ['Dành riêng cho hạng {0}', 'Exclusive for {0} tier'],
    ['Bắt đầu tích điểm', 'Start earning'],
    ['Tham gia chương trình thành viên', 'Join loyalty program'],
    ['Tham gia chương trình thành viên để nhận những ưu đãi dành riêng!', 'Let\'s join loyalty program to earn exclusive rewards!'],
    ['Nhắc đổi ưu đãi', 'Rewards reminder'],
    ['Số điểm của bạn đã đủ để đổi một ưu đãi!', 'Your points are enough to redeem a reward!'],
    ['Đổi ngay', 'Redeem now'],
    ['{0} điểm', '{0} points'],
  ];

  /* 15 KHOÁ KHÔNG CÓ Ô ADMIN — chiều ngược lại: TRANG VIỆT vẫn lòi tiếng Anh.
     website-theme-72 đo 15/09 21:50: window.BloyTranslationAll.en có 161 khoá, 15 khoá
     này app không cho gõ tiếng Việt (SPEC-BLOY-BANG-VI-EN-15-09.md, mục BỔ SUNG).
     Anh Thắng: "có cách nào ghi đè không, không đổi được thì thôi" → ghi đè hai lớp:
       (1) vá thẳng object window.BloyTranslationAll.en TRƯỚC khi widget vẽ — app embed
           đặt object inline trong <head>, script này defer nên thường đã có sẵn; chưa có
           thì rình tới 30 s. Placeholder {{Tiers}}/{{Points}}/{{Days}} app tự điền.
       (2) phòng widget đã vẽ trước hoặc giữ bản sao riêng: tráo text node EN→VI bằng
           chính bộ máy dich()/traoTrong() bên dưới (đảo chiều so với BANG).
     Trên /en không đụng: 15 khoá này vốn là tiếng Anh. Khoá passkit_* chỉ hiện khi bật
     PassKit (đang Not integrated) — dịch sẵn cho đủ. */
  var GHI_DE_VI = {
    login_text: ['Log in', 'Đăng nhập'],
    online_store: ['Online Store', 'Cửa hàng trực tuyến'],
    vip_order_unit: ['order', 'đơn'],
    vip_orders_unit: ['orders', 'đơn'],
    exclusive_tier: ['Exclusive for {{Tiers}} tier', 'Dành riêng cho hạng {{Tiers}}'],
    exclusive_tier_badge: ['Exclusive tier', 'Hạng đặc biệt'],
    exclusive_tier_note: ['You are in an exclusive tier', 'Bạn đang ở hạng đặc biệt'],
    activity_points_pending: ['Pending {{Points}} ({{Days}} days)', 'Đang chờ {{Points}} ({{Days}} ngày)'],
    referral_program_claim_pending_title: ['Thanks! Your reward is being reviewed', 'Cảm ơn bạn! Phần thưởng đang được xét duyệt'],
    referral_program_claim_pending_description: ['We\'ll email your discount code once it\'s approved.', 'Chúng tôi sẽ thông báo qua email sau khi được duyệt.'],
    // 17/09 09:45 — popup B sau khi nhập email (SPEC-GIOI-THIEU-UI-KHOA-3): 2 khoá này KHÔNG có trong
    // BloyTranslationAll (161 khoá, đo 17/09) nên popup.bloy.js rơi về chữ Anh cứng `|| "Thanks! You've been referred"`;
    // vá object là app đọc được (khoá vắng thì thêm). Dòng từ chối referral_program_email_error_3 đã Việt sẵn.
    referral_program_claim_tracked_title: ['Thanks! You\'ve been referred', 'Cảm ơn bạn! Đã ghi nhận lời mời'],
    referral_program_claim_tracked_description: ['The shop will follow up with your gift soon.', 'Quà sẽ được gói kèm đơn hàng đầu tiên của bạn.'],
    passkit_label_name: ['Name', 'Tên'],
    passkit_label_points: ['Points', 'Điểm'],
    passkit_label_tier: ['Tier', 'Hạng'],
    passkit_qr_instruction: ['Scan this QR on your phone or click it to add your wallet pass', 'Quét mã QR bằng điện thoại hoặc bấm vào để thêm thẻ vào ví'],
    passkit_add_to_wallet: ['Add to wallet', 'Thêm vào ví']
  };

  /* 16/09 — CHỮ REFERRAL THEO CHƯƠNG TRÌNH DERMA (khoá CÓ ô admin, nhưng BLOY đang không lưu
     được panel). Khác GHI_DE_VI: áp cho MỌI ngôn ngữ, vì bộ chữ gốc của app là tiếng Việt và
     /en tráo VI→EN bằng BANG ở trên (đã thêm cặp). [chữ cũ trong app, chữ mới]. Khi BLOY sửa
     lỗi và website-theme nhập chữ mới vào admin thì vế "cũ" ở đây hết khớp — vô hại, vì lớp này
     ghi đè theo KHOÁ chứ không theo chữ. */
  var DOI_CHU = {
    referral_program_description: ['Tặng bạn bè một ưu đãi, và nhận phần của bạn khi họ mua hàng', 'Giới thiệu bạn mua Dermalogica lần đầu — cả hai cùng nhận quà.'],
    referral_points_description: ['Tặng bạn bè một ưu đãi, và nhận phần của bạn khi họ mua hàng', 'Giới thiệu bạn mua Dermalogica lần đầu — cả hai cùng nhận quà.'],
    referral_reward_value: ['Giảm {{DiscountValue}}', 'Đơn đầu từ 1,5 triệu: Bộ dùng thử các bước nền tảng · từ 2,5 triệu: thêm Phiếu quy đổi Dịch Vụ Tăng Cường'],
    /* 16/09 23:15 — referral_program_you_get / referral_points_you_get KHÔNG ghi đè nữa: giữ "Bạn nhận" cho cân
       với thẻ 1; phần quà người giới thiệu vẽ ở ô giá trị (MOC_BAN_NHAN trong chiaMoc) thay vì giấu. */
    get_your_coupon: ['Nhận mã ưu đãi', 'Đăng ký nhận quà'],
    you_got_gift: ['Bạn có một món quà từ bạn bè! Nhập mã này khi thanh toán để nhận ưu đãi', 'Bạn có quà từ bạn bè! Nhập email để được ghi nhận — quà gửi kèm đơn đầu tiên: từ 1,5 triệu nhận Bộ dùng thử các bước nền tảng, từ 2,5 triệu thêm Phiếu quy đổi Dịch Vụ Tăng Cường'],
    claim_coupon: ['Nhận mã', 'Đăng ký'],
    referral_program_your_discount: ['Mã giảm giá của bạn', 'Đã ghi nhận! Quà sẽ gửi kèm đơn đầu tiên của bạn']
  };

  /* Chiều tráo theo ngôn ngữ trang: tiếng Việt → EN→VI (15 khoá trên);
     còn lại (/en) → VI→EN (bảng BANG). */
  var ngonNgu = (document.documentElement.getAttribute('lang') || '').toLowerCase();
  if (!ngonNgu && window.Shopify && window.Shopify.locale) ngonNgu = String(window.Shopify.locale).toLowerCase();
  var laVi = ngonNgu.indexOf('vi') === 0;
  var canTrao = true;

  /* Lớp (1): vá object dịch của app. GHI_DE_VI chỉ trang Việt; DOI_CHU (16/09) mọi ngôn ngữ. */
  (function vaObject() {
    var lan = 0;
    function thu() {
      // 18/09 13:00 — BLOY đổi bundle (bloy-loyalty-750): object dịch giờ là window.BloyTranslation (phẳng, 159 khoá,
      // = __BloyLocaleResources.en.popup); BloyTranslationAll không còn → lớp (1) đã im lặng mấy ngày (lớp (2) tráo text
      // node vẫn gánh, nên chỉ lộ ở /en khách lạ: thẻ "They get 0% off"). Nhận cả hai tên, tên nào có thì vá.
      var o = window.BloyTranslationAll && window.BloyTranslationAll.en ? window.BloyTranslationAll.en
        : (window.BloyTranslation && typeof window.BloyTranslation === 'object' ? window.BloyTranslation : null);
      if (o) {
        if (laVi) for (var k in GHI_DE_VI) if (GHI_DE_VI.hasOwnProperty(k)) o[k] = GHI_DE_VI[k][1];
        for (var k1 in DOI_CHU) if (DOI_CHU.hasOwnProperty(k1)) o[k1] = DOI_CHU[k1][1];
        return true;
      }
      return false;
    }
    if (thu()) return;
    var dongHoVa = window.setInterval(function () {
      if (thu() || ++lan > 600) window.clearInterval(dongHoVa);
    }, 50);
  })();

  /* --- chuẩn bị bảng tra --- */
  var chinhXac = {};   // câu không có {0}
  var mauCau = [];     // câu có {0}: {re, en}

  /* Đưa {{Tên}} của app về {0},{1}… theo thứ tự xuất hiện ở vế nguồn, để dùng
     chung cơ chế chụp-đặt với BANG. */
  function chuanHoa(nguon, dich) {
    var thuTu = [];
    nguon = nguon.replace(/\{\{(\w+)\}\}/g, function (_, ten) {
      var i = thuTu.indexOf(ten);
      if (i < 0) { thuTu.push(ten); i = thuTu.length - 1; }
      return '{' + i + '}';
    });
    dich = dich.replace(/\{\{(\w+)\}\}/g, function (_, ten) {
      var i = thuTu.indexOf(ten);
      return i < 0 ? '' : '{' + i + '}';
    });
    return [nguon, dich];
  }

  var CAP = [];   // [nguồn, đích]
  if (laVi) {
    for (var k2 in GHI_DE_VI) if (GHI_DE_VI.hasOwnProperty(k2)) CAP.push(chuanHoa(GHI_DE_VI[k2][0], GHI_DE_VI[k2][1]));
    for (var k3 in DOI_CHU) if (DOI_CHU.hasOwnProperty(k3)) CAP.push(chuanHoa(DOI_CHU[k3][0], DOI_CHU[k3][1]));
  } else {
    CAP = BANG;
  }

  for (var i = 0; i < CAP.length; i++) {
    var nguon = CAP[i][0];
    var dichRa = CAP[i][1];
    if (nguon.indexOf('{0}') < 0) {
      chinhXac[nguon] = dichRa;
      continue;
    }
    // Thoát ký tự đặc biệt của phần chữ, chừa {n} làm chỗ chụp.
    var re = nguon.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\\\{(\d)\\\}/g, '(.+?)');
    mauCau.push({ re: new RegExp('^' + re + '$'), en: dichRa });
  }

  function dich(chu) {
    if (chinhXac[chu]) return chinhXac[chu];
    for (var i = 0; i < mauCau.length; i++) {
      var m = chu.match(mauCau[i].re);
      if (!m) continue;
      return mauCau[i].en.replace(/\{(\d)\}/g, function (_, n) {
        var phan = m[Number(n) + 1] || '';
        return laVi ? phan : donVi(phan);
      });
    }
    return null;
  }

  /* Phần app điền vào {n} ("1 điểm", "500 điểm") mang tên đơn vị điểm đặt ở
     Settings › Points (tiếng Việt, dùng chung mọi ngôn ngữ) — đo 15/09 trên /en:
     "1 điểm for every 24,000₫ spent". Đổi riêng đơn vị trong phần chụp được. */
  function donVi(s) {
    return s.replace(/^(\d[\d.,]*)\s+điểm$/, function (_, k) {
      return k + (k === '1' ? ' point' : ' points');
    }).replace(/\bđiểm\b/g, 'points');
  }

  var dangGhi = false;   // chặn vòng lặp: bản thân mình ghi cũng làm observer nổ

  /* CHUÔNG BÁO LỆCH — thứ giữ cho bảng này khỏi mục nát âm thầm.
     Mai kia Dermalogica sửa chữ trong app hoặc đặt tên phần thưởng mới mà quên
     cập nhật bảng trên, câu đó lặng lẽ hiện tiếng Việt cho khách xem bản tiếng
     Anh, không có lỗi nào báo. Nên: gặp chữ CÓ DẤU TIẾNG VIỆT mà không tra
     được thì gom lại, kêu một tiếng ở console và treo lên
     window.eguruBloyThieu để soi bằng một dòng lệnh.
     Chỉ chạy ở trang tiếng Anh nên khách Việt không tốn gì. */
  var CO_DAU = /[ăâđêôơưÁÀẢÃẠĂẮẰẲẴẶÂẤẦẨẪẬÉÈẺẼẹÊẾỀỂỄỆÍÌỈĨỊÓÒỎÕỌÔỐỒỔỖỘƠỚỜỞỠỢÚÙỦŨỤƯỨỪỬỮỰÝỲỶỸỴáàảãạắằẳẵặấầẩẫậéèẻẽẹếềểễệíìỉĩịóòỏõọốồổỗộớờởỡợúùủũụứừửữựýỳỷỹỵ]/;
  var daKeu = {};
  window.eguruBloyThieu = window.eguruBloyThieu || [];

  function keuThieu(chu) {
    if (daKeu[chu]) return;
    daKeu[chu] = true;
    window.eguruBloyThieu.push(chu);
    if (window.console && console.warn) {
      console.warn('[eGURU] BLOY: chưa có bản tiếng Anh cho — "' + chu +
        '". Thêm vào bảng BANG trong assets/custom-bloy.js.');
    }
  }

  function traoTrong(goc) {
    if (!canTrao || dangGhi || !goc) return;
    var di = goc.ownerDocument.createTreeWalker(goc, NodeFilter.SHOW_TEXT, null);
    var can = [];
    var n;
    while ((n = di.nextNode())) {
      var chu = (n.nodeValue || '').trim();
      if (!chu || chu.length > 120) continue;
      var moi = dich(chu);
      if (moi) can.push([n, moi]);
      else if (!laVi && CO_DAU.test(chu)) keuThieu(chu);   // chuông chỉ có nghĩa trên /en
    }
    if (!can.length) return;
    dangGhi = true;
    for (var i = 0; i < can.length; i++) can[i][0].nodeValue = can[i][1];
    dangGhi = false;
  }

  /* --- phần mở/đóng: gắn lớp cho CSS --- */
  var popup = null;
  var dongHo = null;

  function soi() {
    if (!popup) return;
    var s = window.getComputedStyle(popup);
    var dangMo = s.visibility !== 'hidden' && parseFloat(s.opacity) > 0.1;
    document.documentElement.classList.toggle(LOP, dangMo);
  }

  /* Soi dồn 1,5 giây — đủ phủ hết hiệu ứng mở/đóng của BLOY.
     ĐÃ THỬ VÀ ĐÃ HỎNG: MutationObserver trên chính .BLOY-popup. Chụp DOM hai
     trạng thái rồi so lên bốn tầng cha — không thuộc tính nào đổi, không lớp
     nào đổi, chỉ visibility/opacity đã-tính đổi. Observer thuộc tính không nổ. */
  function soiDon() {
    if (dongHo) window.clearInterval(dongHo);
    var lan = 0;
    dongHo = window.setInterval(function () {
      soi();
      traoIframe();
      if (++lan >= 15) {
        window.clearInterval(dongHo);
        dongHo = null;
      }
    }, 100);
    soi();
  }

  /* --- 16/09: giấu con số điểm và khối mã của referral trong iframe popup ---
     Selector đọc từ bundle popup.bloy.js của app (website-theme 16:42), không phải đoán:
       panel A  .BLOY-popup__referral_rewards > .BLOY-popup__referral_reward ×2 — [1] họ nhận
                (value lấy từ ô dịch referral_reward_value → đã đổi chữ), [2] bạn nhận với
                .BLOY-popup__referral_reward_value = format(earnPoint) "300 điểm" KHÔNG qua ô
                dịch → chỉ giấu span này, chữ "Bạn nhận quà mini-size…" bên cạnh giữ.
       popup B  sau khi nhập email: input.BLOY-popup__referral_discount_input (mã) +
                .BLOY-popup__referral_btn_group (Sao chép / Áp dụng → /discount/<mã>) → giấu;
                .BLOY-popup__referral_text giữ vì còn dùng cho "Gửi liên kết này cho bạn bè".
     Chèn <style> vào document của iframe (cùng gốc) — CSS của theme không vào được iframe.
     Bỏ lớp này khi BLOY hạ thưởng mặc định về 0 và Derma chấp nhận widget gốc. */
  // 16/09 23:15: ô giá trị thẻ 2 ("300 điểm") không ẩn nữa — chiaMoc() thay chữ bằng 2 dòng quà người giới thiệu
  var CSS_GIAU = '.BLOY-popup__referral_discount_input,.BLOY-popup__referral_btn_group{display:none!important}';

  /* 16/09 22:30 — UI WIDGET TRONG IFRAME (anh Thắng: "toàn chữ mà khung bé", sửa gấp để duyệt).
     Số đo website-theme đưa: chữ 16px/1.6 #1a1a1a, tiêu đề mục 18px/600, khối padding 20px cách nhau
     16px, thẻ giới thiệu nền #f5f5f5 bo 12px padding 16px icon 32px, nhãn nhỏ 13px in hoa mờ, giá trị
     16px/600, nút 48px. Khung ngoài (.BLOY-popup 560px) và popup B sửa ở custom-third-party.css vì
     chúng nằm ở document chính. Selector đo trên DOM dev 16/09 22:35. */
  var CSS_UI = ''
    + 'html,body{font-size:16px!important;line-height:1.6!important;color:#1a1a1a!important}'
    + '.BLOY-popup__wrapper{height:100vh!important;max-height:none!important}'
    + '.BLOY-popup__container{height:calc(100vh - 30px)!important;max-height:none!important}'
    + '.BLOY-popup__main-container{padding:0 16px 16px!important}'
    + '.BLOY-popup__section{padding:20px!important;margin-bottom:16px!important;border-radius:14px}'
    + '.BLOY-popup__section:last-child{margin-bottom:0!important}'
    + '.BLOY-popup__login-title,.BLOY-popup__list-title,.BLOY-popup__header--title-second{font-size:18px!important;line-height:1.4!important;font-weight:600!important;color:#1a1a1a!important}'
    + '.BLOY-popup__header--title-first{font-size:14px!important}'
    + '.BLOY-popup__login-body,.BLOY-popup__point-item span{font-size:15px!important;line-height:1.55!important;color:#1a1a1a!important}'
    + '.BLOY-popup__login-signIn{font-size:15px!important;margin-top:10px!important}'
    + '.BLOY-popup__login-join,.BLOY-button{min-height:48px!important;font-size:16px!important;font-weight:600!important;border-radius:10px!important}'
    + '.BLOY-popup__referral-program .BLOY-popup__point-item span{display:block;margin-bottom:12px}'
    + '.BLOY-popup__referral_rewards{display:grid!important;gap:12px!important}'
    + '.BLOY-popup__referral_reward{display:flex!important;gap:12px!important;align-items:flex-start!important;background:#f5f5f5!important;border-radius:12px!important;padding:16px!important;margin:0!important}'
    + '.BLOY-popup__referral_reward_icon,.BLOY-popup__referral_reward_icon svg{width:32px!important;height:32px!important;flex:0 0 32px!important}'
    + '.BLOY-popup__referral_reward_info{display:flex!important;flex-direction:column!important;gap:6px!important;min-width:0}'
    + '.BLOY-popup__referral_reward_receiver{font-size:13px!important;line-height:1.3!important;text-transform:uppercase!important;letter-spacing:.04em!important;color:#6b6b6b!important}'
    + '.BLOY-popup__referral_reward_value{font-size:16px!important;line-height:1.5!important;font-weight:600!important;color:#1a1a1a!important}'
    + '.eguru-moc{display:flex;gap:8px;align-items:flex-start;font-size:16px;line-height:1.5;font-weight:600;color:#1a1a1a}'
    + '.eguru-moc+.eguru-moc{margin-top:6px}'
    + '.eguru-moc-mo{display:block;margin-bottom:10px;font-weight:400}'
    + '.eguru-tick{flex:0 0 auto;color:#2e7d32;font-weight:700}'
    + '.eguru-du-3{font-size:13px!important;line-height:1.5!important;color:#6b6b6b!important;margin-top:6px}'
    // 18/09 09:10 — dòng nhắc điều kiện dưới ô link chia sẻ (anh Thắng chốt: B phải nhập email ở hộp Đăng ký nhận quà)
    + '.eguru-nhac{display:flex!important;gap:8px!important;align-items:flex-start!important;margin-top:10px!important;padding:10px 12px!important;background:#f4f6f8!important;border-radius:10px!important;font-size:13px!important;line-height:1.5!important;color:#3a3a3a!important}'
    + '.eguru-nhac-i{flex:0 0 18px!important;width:18px!important;height:18px!important;border-radius:50%!important;border:1.5px solid #6b6b6b!important;color:#6b6b6b!important;font:700 11px/15px Georgia,serif!important;text-align:center!important;margin-top:1px!important}'
    + '.eguru-voucher{font-size:15px!important;font-weight:600!important;color:#1a1a1a!important;margin-top:6px}'
    // 17/09 phương án C: nút mời qua email của BLOY gửi link không có &gt= → ẩn (chỉ giữ ô link + sao chép + mạng xã hội)
    + '.BLOY-popup__referral_social_item:not(.st-custom-button){display:none!important}'
    + '.BLOY-popup__header{height:auto!important;min-height:0!important;padding:52px 20px 46px!important}'
    + '.BLOY-popup__header--title{position:static!important;top:auto!important;bottom:auto!important;transform:none!important;margin:0!important}'
    // 16/09 23:30 — cuộn xuống BLOY gắn .BLOY-popup--fixed: header absolute 50px (thanh mỏng, tiêu đề mờ) và ruột
    // translateY(140 = 170 − 30). Padding cố định ở trên làm header vẫn 143px → khối xám trống đè ruột (ảnh ui-13).
    // Biến --eguru-dau = chiều cao header lúc chưa cuộn, khopCao() đo và ghi lên <html> của iframe.
    + '.BLOY-popup--fixed .BLOY-popup__header{height:50px!important;padding:0!important}'
    + '.BLOY-popup--fixed .BLOY-popup__header--title{display:none!important}'
    + '.BLOY-popup--fixed .BLOY-popup__main{transform:translateY(calc(var(--eguru-dau, 143px) - 30px))!important}'
    + '@media (max-width:480px){html,body{font-size:15px!important}.BLOY-popup__main-container{padding:0 10px 10px!important}.BLOY-popup__section{padding:14px!important;margin-bottom:10px!important;border-radius:12px}.BLOY-popup__header{padding:48px 16px 42px!important}.BLOY-popup__referral_reward{padding:12px!important;gap:10px!important}.BLOY-popup__referral_reward_icon,.BLOY-popup__referral_reward_icon svg{width:28px!important;height:28px!important;flex-basis:28px!important}.eguru-moc,.BLOY-popup__referral_reward_value{font-size:15px!important}.BLOY-popup__login-join,.BLOY-button{min-height:44px!important}}'
    + '@media (max-height:640px){.BLOY-popup__header{padding:46px 16px 40px!important}.BLOY-popup__header--title-first{display:none!important}.BLOY-popup__section{padding:12px 14px!important;margin-bottom:8px!important}.BLOY-popup__login-body{margin-bottom:8px!important}.BLOY-popup__referral_rewards{gap:8px!important}.BLOY-popup__referral_reward{padding:10px 12px!important}}'
    ;
  /* 02/10 anh Thắng: quà người giới thiệu (lượt 1–2) gửi về địa chỉ trong hồ sơ → hồ sơ chưa có địa chỉ + SĐT
     (window.eguruKhach.diaChiDu === false, layout/theme.liquid) thì giấu ô link + nút chia sẻ trong hộp BLOY,
     nhắc khách thêm địa chỉ ở trang Giới thiệu bạn bè. khoi-gioi-thieu.js vẫn đọc được ô link (chỉ ẩn bằng CSS). */
  function cssCanDiaChi() {
    var k = window.eguruKhach;
    if (!k || k.diaChiDu !== false) return '';
    var nhac = laVi ? 'Thêm địa chỉ và số điện thoại nhận quà ở trang Giới thiệu bạn bè để lấy link của bạn.'
                    : 'Add your delivery address and phone number on the Refer a friend page to get your link.';
    return '.BLOY-popup__referral_sharing_url,.BLOY-popup__referral_social_item,.BLOY-popup__referral_text{display:none!important}'
      + '.BLOY-popup__referral_rewards::after{content:' + JSON.stringify(nhac) + ';display:block;margin-top:4px;padding:10px 12px;background:#f4f6f8;border-radius:10px;font-size:14px;line-height:1.5;color:#3a3a3a}';
  }
  function giauThuong(d) {
    if (!d || !d.head || d.getElementById('eguru-giau-thuong')) return;
    var st = d.createElement('style');
    st.id = 'eguru-giau-thuong';
    st.textContent = CSS_GIAU + CSS_UI + (CHI_REFER ? CSS_CHI_REFER : (AN_REFER ? CSS_AN_REFER : '')) + cssCanDiaChi();
    d.head.appendChild(st);
  }

  /* 18/09 12:06 — CHỈ HIỆN GIỚI THIỆU BẠN BÈ (anh Thắng, sau demo với Derma: widget khó dùng, thấy cả phần điểm/VIP
     còn dở dang). Công tắc MỘT CHỖ: Customize › Theme settings › "Điểm thưởng & Giới thiệu (BLOY)" › "Chỉ hiện Giới
     thiệu bạn bè" → layout/theme.liquid gắn lớp eguru-chi-refer lên <body>. 25/09 mở VIP/tích điểm: TẮT công tắc là
     hiện lại hết, không sửa code.
       - Nút nổi: chữ "Điểm thưởng" → "Giới thiệu bạn bè" (doiTenNut). Làm ở theme chứ không đổi Branding trong app:
         app dùng chung dev/live, đổi là live đổi ngay và không có công tắc.
       - Trong iframe, MÀN CHÍNH [data-page="home"] (đã đăng nhập) / [data-page="login"] (khách lạ): mỗi .BLOY-popup__section KHÔNG chứa khối giới thiệu (CHON_REFER) và
         không phải ô Đăng nhập/Tham gia (.BLOY-popup__login — khách lạ cần nó để có link) → gắn lớp eguru-an, CSS giấu.
         Giấu được: Việc tiếp theo, Ưu đãi của bạn, Chương trình VIP, Cách tích điểm/Đổi ưu đãi, Hoạt động của bạn.
         MÀN CON [data-page="referral"] toàn khối giới thiệu (link, ⓘ, nút chia sẻ) → không đụng; màn con khác hết lối vào.
       - Header: giấu dòng "Bạn đang có"/"Chào mừng đến với"; dòng "0 điểm"/"Chương trình tích điểm" → tên chương trình.
         Ở màn con dòng này là "Đã giới thiệu thành công N/3 người" (khoaBaLuot) → không khớp mẫu → giữ.
     FAIL-OPEN (yêu cầu anh Thắng): BLOY đổi DOM mà không thấy khối giới thiệu → KHÔNG giấu section nào; không có
     [data-page] → xét ruột .BLOY-popup__main-container với cùng điều kiện; chữ không khớp mẫu → để nguyên. Chỉ đổi cách
     HIỂN THỊ: BLOY vẫn tích điểm ngầm, thư BLOY/Flow/Klaviyo và popup B (#BLOY-referral__modal) không đổi.
     Đo DOM 18/09 12:15 (popup.bloy.js bloy-loyalty-750): home = becomeMember? + [orderBooster, vipTiers, points, referral,
     activities] theo BloyPopupDesign.theme.homeSectionOrder; section không mang tên → nhận diện bằng ruột. */
  /* 18/09 12:50 — GHI CHỮ MÀ KHÔNG THAY NODE. Widget BLOY là Preact: el.textContent = '…' THAY text node bằng node mới,
     Preact vẫn giữ node cũ (đã rời DOM) và về sau chỉ ghi vào node cũ → DOM không đổi nữa (đo 18/09: header title-second
     đứng chết ở chữ mình ghi khi qua màn con/quay lại; khoaBaLuot cũng vậy). Ghi thẳng .data của text node có sẵn thì
     Preact và mình cùng ghi một node. Node không phải text thuần thì mới dùng textContent. */
  function ghiChu(el, chu) {
    if (!el) return;
    var c = el.firstChild;
    if (c && c.nodeType === 3 && !c.nextSibling) { if (c.data !== chu) c.data = chu; }
    else el.textContent = chu;
  }
  var CHI_REFER = !!(document.body && document.body.classList.contains('eguru-chi-refer'));
  /* 18/09 14:13 anh Thắng (landing đã là mặt tiền referral): chế độ NGƯỢC LẠI — giữ nguyên hộp BLOY (điểm/VIP/ưu đãi/
     hoạt động), chỉ BỎ khối Giới thiệu bạn bè (+ dòng rule "Giới thiệu bạn bè" trong Cách tích điểm). Chỉ ẩn bằng CSS
     (lớp eguru-an) nên khoi-gioi-thieu.js trên landing vẫn bấm được thẻ giới thiệu trong iframe để lấy link. */
  var AN_REFER = !CHI_REFER && !!(document.body && document.body.classList.contains('eguru-an-refer'));
  var TEN_REFER = laVi ? 'Giới thiệu bạn bè' : 'Refer a friend';
  var CHON_REFER = '.BLOY-popup__referral-program, .BLOY-popup__referral-program-container, .BLOY-popup__referral_rewards, .BLOY-popup__referral_sharing_url';
  var CHU_HEADER_DIEM = /^(\d[\d.,]*\s*(điểm|points?)|Chương trình tích điểm|Points program)$/i;
  // [chữ gốc BLOY (VI, hoặc EN sau khi BANG tráo)] → [VI, EN]. Khoá become_a_member / join_points_program của BLOY.
  var CHU_LOGIN_REFER = {
    'Trở thành thành viên': ['Đăng nhập để nhận link giới thiệu', 'Sign in to get your referral link'],
    'Become a member': ['Đăng nhập để nhận link giới thiệu', 'Sign in to get your referral link'],
    'Tham gia chương trình tích điểm để nhận những ưu đãi dành riêng cho thành viên': ['Tạo tài khoản hoặc đăng nhập để lấy link giới thiệu bạn bè của riêng bạn.', 'Create an account or sign in to get your own refer-a-friend link.'],
    'Join the points program to start earning for exclusive rewards': ['Tạo tài khoản hoặc đăng nhập để lấy link giới thiệu bạn bè của riêng bạn.', 'Create an account or sign in to get your own refer-a-friend link.']
  };
  var CSS_CHI_REFER = '.eguru-an{display:none!important}'
    + '.BLOY-popup__header--title-first{display:none!important}';
  var CSS_AN_REFER = '.eguru-an{display:none!important}';
  function chiRefer(d) {
    if ((!CHI_REFER && !AN_REFER) || !d || !d.body) return;
    var trang = d.body.querySelector('[data-page]');
    var goc = null;
    if (!trang) goc = d.body.querySelector('.BLOY-popup__main-container');
    else if (/^(home|login)$/.test(trang.getAttribute('data-page') || '')) goc = trang;   // login = màn khách chưa đăng nhập (đo 18/09)
    if (goc) {
      var khoi = goc.querySelectorAll('.BLOY-popup__section');
      var coRefer = false;
      for (var i = 0; i < khoi.length; i++) if (khoi[i].querySelector(CHON_REFER)) { coRefer = true; break; }
      for (var j = 0; j < khoi.length; j++) {
        var laRefer = !!khoi[j].querySelector(CHON_REFER);
        // chi-refer: giấu mọi section KHÔNG phải giới thiệu (trừ ô đăng nhập); an-refer: giấu ĐÚNG section giới thiệu
        var an = CHI_REFER ? (coRefer && !khoi[j].classList.contains('BLOY-popup__login') && !laRefer) : laRefer;
        if (khoi[j].classList.contains('eguru-an') !== an) khoi[j].classList.toggle('eguru-an', an);
      }
    }
    if (AN_REFER) {
      // dòng rule "Giới thiệu bạn bè" trong màn Cách tích điểm cũng là referral → giấu (nhận diện đúng tên rule, fail-open)
      var hang = d.body.querySelectorAll('.BLOY-popup__list-item');
      for (var h = 0; h < hang.length; h++) {
        var ten = hang[h].querySelector('.BLOY-popup__text--primary');
        if (ten && TEN_RULE_GIOI_THIEU.test((ten.textContent || '').trim()) && !hang[h].classList.contains('eguru-an')) hang[h].classList.add('eguru-an');
      }
      return;
    }
    var t2 = d.body.querySelector('.BLOY-popup__header--title-second');
    if (t2 && CHU_HEADER_DIEM.test((t2.textContent || '').replace(/\s+/g, ' ').trim())) {
      dangGhi = true; ghiChu(t2, TEN_REFER); dangGhi = false;
    }
    // Ô Đăng nhập/Tham gia của khách lạ: chữ gốc BLOY nói "chương trình tích điểm" → đổi sang lý do đăng nhập là lấy link.
    // Chỉ đổi khi chữ đúng bằng bản gốc (VI hoặc đã tráo EN) — BLOY/Derma đổi chữ thì để nguyên (fail-open).
    var oLogin = d.body.querySelectorAll('.BLOY-popup__login-title, .BLOY-popup__login-body');
    for (var l = 0; l < oLogin.length; l++) {
      var moi = CHU_LOGIN_REFER[(oLogin[l].textContent || '').replace(/\s+/g, ' ').trim()];
      if (moi) { dangGhi = true; ghiChu(oLogin[l], moi[laVi ? 0 : 1]); dangGhi = false; }
    }
  }
  function doiTenNut(goc) {
    if (!CHI_REFER || !goc || !goc.querySelectorAll) return;
    var ds = goc.querySelectorAll('.BLOY-widget__title');
    for (var i = 0; i < ds.length; i++) {
      var chu = (ds[i].textContent || '').trim();
      if (chu && chu !== TEN_REFER) { dangGhi = true; ghiChu(ds[i], TEN_REFER); dangGhi = false; }
    }
  }

  /* 16/09 22:40 — TÁCH CHỮ 2 MỐC THÀNH 2 DÒNG CÓ ✓ (anh Thắng duyệt bố cục).
     BLOY chỉ có MỘT ô chữ cho "Bạn của bạn nhận" và một ô cho câu chào ở popup B, nên hai mốc
     1,5tr / 2,5tr đang dính thành một chuỗi dài. Lớp này vẽ lại innerHTML: phần mở đầu (nếu có)
     rồi mỗi mốc một dòng; dấu ✓ nằm span riêng để lớp tráo VI→EN vẫn khớp từng dòng qua BANG.
     Idempotent: đã có .eguru-moc thì bỏ qua. Chạy cho cả iframe (panel A) và document chính
     (popup B, #BLOY-referral__modal). Khoá của MOC = đúng chuỗi trong DOI_CHU/BANG. */
  var MOC = {
    // 17/09 09:55 — thẻ 1 widget đồng bộ với popup B: "Đơn đầu tiên" ở cả 2 dòng (anh Thắng, qua website-theme-e9). Khoá giữ nguyên = chữ DOI_CHU referral_reward_value.
    'Đơn đầu từ 1,5 triệu: Bộ dùng thử các bước nền tảng · từ 2,5 triệu: thêm Phiếu quy đổi Dịch Vụ Tăng Cường': { dong: ['Đơn đầu tiên từ 1,5 triệu: Bộ dùng thử các bước nền tảng', 'Đơn đầu tiên từ 2,5 triệu: Bộ dùng thử các bước nền tảng + Phiếu quy đổi Dịch Vụ Tăng Cường'] },
    'First order from 1.5M₫: the Foundation Trial Kit · from 2.5M₫: plus a Professional Treatment Enhancement voucher': { dong: ['Your first order from 1.5M₫: the Foundation Trial Kit', 'Your first order from 2.5M₫: the Foundation Trial Kit + a Professional Treatment Enhancement voucher'] },
    // 17/09 09:45 (SPEC-GIOI-THIEU-UI-KHOA-3): popup B nói rõ "Đơn đầu tiên" ở cả 2 dòng kẻo hiểu là đơn sau cũng được
    'Bạn có quà từ bạn bè! Nhập email để được ghi nhận — quà gửi kèm đơn đầu tiên: từ 1,5 triệu nhận Bộ dùng thử các bước nền tảng, từ 2,5 triệu thêm Phiếu quy đổi Dịch Vụ Tăng Cường': { mo: 'Bạn có quà từ bạn bè! Nhập email để được ghi nhận — quà gửi kèm đơn đầu tiên:', dong: ['Đơn đầu tiên từ 1,5 triệu: Bộ dùng thử các bước nền tảng', 'Đơn đầu tiên từ 2,5 triệu: Bộ dùng thử các bước nền tảng + Phiếu quy đổi Dịch Vụ Tăng Cường'] },
    'You\'ve got a gift from a friend! Enter your email to be registered — the gift ships with your first order: from 1.5M₫ the Foundation Trial Kit, from 2.5M₫ plus a Professional Treatment Enhancement voucher': { mo: 'You\'ve got a gift from a friend! Enter your email to be registered — the gift ships with your first order:', dong: ['Your first order from 1.5M₫: the Foundation Trial Kit', 'Your first order from 2.5M₫: the Foundation Trial Kit + a Professional Treatment Enhancement voucher'] }
  };
  /* 16/09 22:55 — KHỚP CHIỀU CAO KHUNG WIDGET THEO RUỘT. BLOY đặt height theo viewport rồi cắt bằng
     max-height; khi nới khung lên 560px ruột ngắn lại nên dư một khoảng xám trống dưới đáy. Đo
     scrollHeight của document trong iframe rồi đặt height cho .BLOY-popup (trần 88vh, sàn 320px);
     ruột dài hơn trần thì iframe tự cuộn như cũ. Chạy sau mỗi lần BLOY vẽ lại (observer). */
  var khopCaoHen = 0;
  var khopCaoThem = 0;   // số lần đo lại liên tiếp (xem cuối hàm)
  function khopCao(d) {
    if (!popup || !d || !d.documentElement) return;
    if (khopCaoHen) return;
    khopCaoHen = window.requestAnimationFrame(function () {
      khopCaoHen = 0;
      var boc = d.querySelector('.BLOY-popup__wrapper');
      var dau = d.querySelector('.BLOY-popup__header');
      // 16/09 22:52 — chỗ trống thật = màn hình trừ nút launcher (BLOY neo bottom 96px) và lề trên 12px;
      // màn thấp thì trần này nhỏ hơn 88vh, nếu không khung tràn lên khỏi đỉnh và mất phần đầu.
      // neo đáy đọc từ CSS thật của BLOY thay vì trừ cứng 96. Chiều cao màn lấy visualViewport (điện thoại: thanh
      // địa chỉ ẩn/hiện làm innerHeight lệch) — 17/09 00:26 anh Thắng: thu cửa sổ khung không co, đáy bị cắt.
      var manCao = (window.visualViewport && window.visualViewport.height) || window.innerHeight;
      var neoDay = parseFloat(window.getComputedStyle(popup).bottom) || 96;
      var tran = Math.min(Math.floor(manCao * 0.88), Math.floor(manCao) - neoDay - 12);
      // đang cuộn (--fixed): header rời khỏi dòng chảy nên scrollHeight hụt đúng chiều cao header → không đo ruột,
      // nhưng vẫn ép trần (chỉ co lại khi cửa sổ nhỏ đi, không nới) — trước 17/09 chỗ này return sớm nên resize không co.
      if (boc && /BLOY-popup--fixed/.test(boc.className)) {
        if (popup.getBoundingClientRect().height > tran) popup.style.setProperty('height', Math.max(280, tran) + 'px', 'important');
        return;
      }
      if (dau && dau.offsetHeight > 60) d.documentElement.style.setProperty('--eguru-dau', dau.offsetHeight + 'px');
      var thung = d.querySelector('.BLOY-popup__container');
      // 18/09 12:30 — đo 18/09: CSS_UI ép .BLOY-popup__container cao calc(100vh - 30px) nên scrollHeight của nó = chính nó
      // (vòng tròn: khung không bao giờ CO khi ruột ngắn — lộ ra khi chỉ còn khối Giới thiệu bạn bè, dư ~350px xám).
      // Đo ruột thật = mép dưới thấp nhất của các phần con (thanh nút, header, .BLOY-popup__main — main dịch translateY(-30)
      // đè lên header nên cộng chiều cao từng phần sẽ dư 30) tính từ mép trên container; container mới là thứ cuộn nên
      // rect của main = trọn ruột. Không đo được thì rơi về cách cũ.
      var ruot = d.documentElement.scrollHeight;
      if (thung) {
        var dinh = thung.getBoundingClientRect().top - thung.scrollTop, day = 0;   // container đã cuộn thì rect con dịch lên → bù scrollTop
        for (var p = 0; p < thung.children.length; p++) day = Math.max(day, thung.children[p].getBoundingClientRect().bottom - dinh);
        ruot = (day > 0 ? day : thung.scrollHeight) + 30;   // 30 = phần BLOY chừa cho nút đóng
      }
      if (!ruot || ruot < 100) return;
      var cao = Math.max(280, Math.min(ruot + 2, tran));
      var caoCu = popup.getBoundingClientRect().height;
      popup.style.setProperty('height', cao + 'px', 'important');
      // 18/09 12:40 — CSS_UI có @media (max-height:640px) TRONG iframe: khung co qua mốc 640 là header/section gọn lại,
      // ruột ngắn thêm ~60px (và ngược lại khi nới) → đo lại tối đa 2 lần nữa cho khớp, chỉ khi chiều cao thực sự đổi.
      if (Math.abs(cao - caoCu) > 2 && khopCaoThem < 2) { khopCaoThem++; khopCao(d); } else khopCaoThem = 0;
    });
  }

  /* 16/09 23:15 (website-theme): thẻ 2 "Bạn nhận" — BLOY in "300 điểm" (thưởng mặc định chưa tắt được);
     thay bằng 2 dòng theo chương trình Derma, khớp chữ trang /pages/refer-a-friend. Nhận diện theo
     VỊ TRÍ (thẻ thứ 2) vì chữ gốc là số điểm động. Chữ VI; /en tráo từng dòng qua BANG như các mốc khác. */
  var MOC_BAN_NHAN = { dong: ['Lượt 1–2: 01 Special Cleansing Gel 15ml, gửi khi đơn của bạn bè giao xong', 'Từ lượt 3: mỗi lượt một voucher dịch vụ 20% tiền hàng đơn đó'] };   // 28/09: luật hiện hành (HUONG-DAN-GIOI-THIEU-BAN-BE-25-09)
  var CHON_BAN_NHAN = '.BLOY-popup__referral_rewards .BLOY-popup__referral_reward:nth-child(2) .BLOY-popup__referral_reward_value';

  /* 17/09 00:26 (anh Thắng qua website-theme): màn "Cách tích điểm" có dòng rule referral "Giới thiệu bạn bè — 0 điểm"
     (tên rule đã đổi trong BLOY admin; điểm 0 vì thưởng thật là quà, không phải điểm). Thay chữ "0 điểm" bằng
     câu quà; KHÔNG ẩn hàng. Nhận diện theo tên rule (VI hoặc đã tráo EN) và chỉ khi giá trị đúng là 0 điểm/points.
     Chữ VI; /en tráo qua BANG (đã thêm cặp). */
  var TEN_RULE_GIOI_THIEU = /^(Giới thiệu bạn bè|Refer a friend)$/i;
  var KHONG_DIEM = /^0\s*(điểm|points?)$/i;
  var CHU_RULE_GIOI_THIEU = 'Quà cảm ơn hoặc voucher cho bạn, bộ dùng thử cho bạn của bạn';
  function suaHangGioiThieu(goc) {
    if (!goc || !goc.querySelectorAll) return;
    var ds = goc.querySelectorAll('.BLOY-popup__list-item .BLOY-popup__item-detail');
    for (var i = 0; i < ds.length; i++) {
      var ten = ds[i].querySelector('.BLOY-popup__text--primary');
      var gia = ds[i].querySelector('.BLOY-popup__text--subdued');
      if (!ten || !gia) continue;
      if (!TEN_RULE_GIOI_THIEU.test((ten.textContent || '').trim())) continue;
      if (!KHONG_DIEM.test((gia.textContent || '').trim())) continue;
      dangGhi = true;
      gia.textContent = CHU_RULE_GIOI_THIEU;
      dangGhi = false;
    }
  }

  /* 17/09 09:45 (SPEC-GIOI-THIEU-UI-KHOA-3, anh Thắng chốt 09:30): thẻ "Giới thiệu bạn bè" của thành viên hiện
     referral_points_completed = "Đã giới thiệu thành công {{ReferralsCompletedCount}} người" (BLOY đếm). [28/09: bỏ trần 3, xem trong hàm.] Chương trình
     kết thúc ở 3 lượt → hiện "N/3 người", N>3 vẫn "3/3"; N≥3 thêm dòng nhỏ báo Dermalogica sẽ liên hệ. Không dùng
     metafield, số thật xem trong app BLOY. Chữ VI; /en tráo qua BANG (mẫu {0} chụp được "2/3"). Cùng khoá dịch còn
     hiện ở tiêu đề header khi vào màn con /referral (.BLOY-popup__header--title-second) → khoá số, không thêm dòng. */
  /* 17/09 10:30 — PHƯƠNG ÁN C (anh Thắng chốt 10:19): THEME TỰ NỐI NGƯỜI GIỚI THIỆU.
     Shopify không biết ai giới thiệu ai (chỉ BLOY biết, trigger Flow của BLOY không bắn). Link BLOY của thành
     viên A là https://host/?bloy_ref=CODE → gắn thêm &gt=<customer.id của A> ở MỌI ngả chia sẻ trong widget:
     ô link (.BLOY-popup__referral_url_input), nút sao chép (BLOY copy từ state qua navigator.clipboard.writeText /
     execCommand — phải bọc hàm của cửa sổ iframe), nút mạng xã hội (ShareThis đọc data-url; Messenger và ShareThis
     đều mở bằng window.open của iframe → bọc luôn, gt chèn dạng mã hoá %26gt%3D). Nút mời qua EMAIL của BLOY gửi
     link từ máy chủ BLOY, không có gt → ẩn (CSS_UI). Phía B: assets/gioi-thieu-ban-be.js nhận ?gt= và ghi thuộc
     tính đơn gioi_thieu_boi; Flow (website-theme) đọc và ghi metafield gioi_thieu.* cho A. */
  var KHACH = window.eguruKhach && window.eguruKhach.id ? window.eguruKhach : null;
  // 18/09 00:50: Flow C2 thu hồi voucher ghi "-" vào metafield (Shopify không cho ghi rỗng) → coi "-" là chưa có mã.
  if (KHACH && KHACH.voucher && String(KHACH.voucher).trim() === '-') KHACH.voucher = '';
  function themGt(chu) {
    if (!KHACH || typeof chu !== 'string') return chu;
    var id = String(KHACH.id);
    if (/bloy_ref=[A-Za-z0-9_-]+/.test(chu) && !/[?&]gt=/.test(chu)) return chu.replace(/(bloy_ref=[A-Za-z0-9_-]+)/, '$1&gt=' + id);
    if (/bloy_ref%3D[A-Za-z0-9_-]+/i.test(chu) && !/gt%3D/i.test(chu)) return chu.replace(/(bloy_ref%3D[A-Za-z0-9_-]+)/i, '$1%26gt%3D' + id);
    return chu;
  }
  function ganMaGioiThieu(d) {
    if (!KHACH || !d || !d.querySelectorAll) return;
    var w = d.defaultView;
    if (w && !w.__eguruGt) {
      w.__eguruGt = true;
      try {
        var cb = w.navigator.clipboard;
        if (cb && cb.writeText) { var vietGoc = cb.writeText.bind(cb); cb.writeText = function (t) { return vietGoc(themGt(String(t))); }; }
      } catch (e) {}
      try {
        var lenhGoc = d.execCommand;
        d.execCommand = function (c, ui, v) { if (c === 'copy' && typeof v === 'string') v = themGt(v); return lenhGoc.call(d, c, ui, v); };
      } catch (e) {}
      try {
        var moGoc = w.open;
        w.open = function (u) { if (typeof u === 'string') { arguments[0] = themGt(u); } return moGoc.apply(w, arguments); };
      } catch (e) {}
    }
    var o = d.querySelectorAll('.BLOY-popup__referral_url_input');
    for (var i = 0; i < o.length; i++) {
      if (o[i].tagName === 'INPUT') { var moi = themGt(o[i].value); if (moi !== o[i].value) o[i].value = moi; }
      else if (o[i].textContent && /bloy_ref=/.test(o[i].textContent)) { var moi2 = themGt(o[i].textContent.trim()); if (moi2 !== o[i].textContent.trim()) { dangGhi = true; o[i].textContent = moi2; dangGhi = false; } }
    }
    var nut = d.querySelectorAll('.st-custom-button[data-url]');
    for (var k = 0; k < nut.length; k++) { var u = nut[k].getAttribute('data-url') || ''; var u2 = themGt(u); if (u2 !== u) nut[k].setAttribute('data-url', u2); }
  }

  /* 18/09 09:10 — ĐIỀU KIỆN BẮT BUỘC (anh Thắng chốt qua website-theme-48): B PHẢI nhập email ở hộp "Đăng ký nhận quà"
     khi mở link, và đăng nhập/đặt hàng bằng đúng email đó. Không nhập → BLOY không gắn tag gioi-thieu-khach → Flow A
     không tặng quà, Flow B không tính lượt. Nhắc ở 2 chỗ: (A) dưới ô link chia sẻ trong widget (iframe),
     (B) dưới nút Đăng ký của hộp #BLOY-referral__modal (trang). Chữ theo ngôn ngữ trang; dòng A dài >120 ký tự nên
     traoTrong() không đụng, dòng B có cặp trong BANG. CSS: A ở CSS_UI (iframe), B ở custom-third-party.css. */
  var NHAC_A = laVi
    ? 'Bạn bè cần nhập email ở hộp “Đăng ký nhận quà” khi mở link và đặt hàng bằng đúng email đó — quà và lượt giới thiệu được tính theo email này.'
    : 'Your friend needs to enter their email in the “Sign up for your gift” box when opening your link, and order with that same email — the gift and your referral are tracked by that email.';
  var NHAC_B = laVi
    ? 'Nhập email chưa từng đăng nhập hay mua hàng trên web, rồi đặt hàng bằng đúng email đó — quà được tính theo email này. Đừng đăng nhập trước khi bấm Đăng ký.'
    : 'Enter an email that has never been used to sign in or order on our site, then order with that same email — the gift is tracked by this email. Don\'t sign in before you tap Sign up.';
  function nhacDieuKien(goc) {
    if (!goc || !goc.querySelectorAll) return;
    var doc = goc.ownerDocument || goc;
    var a = goc.querySelectorAll('.BLOY-popup__referral_sharing_url');
    for (var i = 0; i < a.length; i++) {
      if (a[i].querySelector('.eguru-nhac-a')) continue;
      var n = doc.createElement('div');
      n.className = 'eguru-nhac eguru-nhac-a';
      var ia = doc.createElement('span'); ia.className = 'eguru-nhac-i'; ia.setAttribute('aria-hidden', 'true'); ia.textContent = 'i';
      var ca = doc.createElement('span'); ca.className = 'eguru-nhac-chu'; ca.textContent = NHAC_A;
      n.appendChild(ia); n.appendChild(ca);
      dangGhi = true; a[i].appendChild(n); dangGhi = false;
    }
    // 18/09 09:30 (anh Thắng): hộp B của BLOY không có nút đóng (chỉ bấm ra ngoài) → thêm × góc phải;
    // bấm × = click lên lớp phủ .BLOY-referral__modal_overlay (đúng đường BLOY đóng), không cảnh báo gì —
    // B mở lại link là hộp hiện lại, đăng ký tiếp được.
    var hopB = goc.querySelectorAll('#BLOY-referral__modal');
    for (var h = 0; h < hopB.length; h++) {
      if (hopB[h].querySelector('.eguru-dong')) continue;
      var x = doc.createElement('button');
      x.type = 'button'; x.className = 'eguru-dong'; x.setAttribute('aria-label', laVi ? 'Đóng' : 'Close'); x.textContent = '×';
      x.addEventListener('click', function (ev) {
        ev.preventDefault(); ev.stopPropagation();
        var phu = doc.querySelector('.BLOY-referral__modal_overlay');
        if (phu) phu.click();
      });
      dangGhi = true; hopB[h].appendChild(x); dangGhi = false;
    }
    var b = goc.querySelectorAll('.BLOY-popup__referral_email_action');
    for (var j = 0; j < b.length; j++) {
      if (b[j].querySelector('.eguru-nhac-b')) continue;
      var m = doc.createElement('div');
      m.className = 'eguru-nhac eguru-nhac-b';
      var ib = doc.createElement('span'); ib.className = 'eguru-nhac-i'; ib.setAttribute('aria-hidden', 'true'); ib.textContent = 'i';
      var cb2 = doc.createElement('span'); cb2.className = 'eguru-nhac-chu'; cb2.textContent = NHAC_B;
      m.appendChild(ib); m.appendChild(cb2);
      dangGhi = true; b[j].appendChild(m); dangGhi = false;
    }
    dangNhapHopB(goc);
    goiYTuChoi(goc);
  }

  /* 05/10/2026 13:34 (anh Thắng): quà giới thiệu CHỈ cho email đăng ký ở hộp BLOY, và BLOY chỉ nhận email CHƯA có tài
     khoản (đo 05/10: tài khoản 0 đơn cũng bị từ chối). Khách ĐANG ĐĂNG NHẬP mở link mời = email đó đã có tài khoản →
     không nhận quà, và nếu gõ email khác thì quà lại ghi sang email kia (dễ hiểu nhầm) → CHẶN: ẩn ô nhập + nút Đăng ký
     của BLOY, báo rõ, nút "Đăng xuất và dùng email khác" (gioi-thieu-ban-be.js mở lại đúng link mời sau khi đăng xuất).
     Bản thử "ghi nhận theo link" sáng 05/10 đã BỎ (không phân biệt chắc khách cũ: khách web cũ / danh sách nhập có
     tài khoản 0 đơn Shopify) — Flow A về lại chỉ xét thẻ gioi-thieu-khach. */
  var KH_DN = window.eguruKhach && window.eguruKhach.id ? window.eguruKhach : null;
  function maGtDangMo() {
    var m = location.search.match(/[?&]gt=(\d{5,20})(?:&|$)/);
    if (m) return m[1];
    try { var o = JSON.parse(localStorage.getItem('gt_ref') || 'null'); return o && o.id ? String(o.id) : ''; } catch (e) { return ''; }
  }
  var CHU_DN = laVi ? {
    dang: 'Bạn đang đăng nhập bằng ',
    chan: 'Quà giới thiệu chỉ dành cho email chưa có tài khoản trên dermalogica.com.vn. Đăng nhập lần đầu là tự tạo tài khoản, nên email bạn đang dùng đã có tài khoản và không nhận được quà này.',
    tieuDeBuoc: 'Muốn nhận quà:',
    buoc: ['Bấm nút bên dưới để đăng xuất — trang sẽ tự mở lại lời mời này.', 'Nhập vào hộp một email chưa từng đăng nhập hay mua hàng trên dermalogica.com.vn, rồi bấm Đăng ký.', 'Đặt đơn đầu tiên bằng đúng email vừa đăng ký. Cần đăng nhập thì chỉ đăng nhập bằng email này.'],
    luuY: 'Trước khi bấm Đăng ký, đừng đăng nhập bằng bất kỳ email nào — kể cả email mới. Email nào đã đăng nhập là thành tài khoản và không nhận quà được nữa.',
    daNhan: 'Email này đã được ghi nhận lời mời — quà áp dụng cho đơn sản phẩm đầu tiên của tài khoản này.',
    chinhMinh: 'Đây là link giới thiệu của chính bạn — gửi link này cho bạn bè để họ nhận quà.',
    thoat: 'Đăng xuất để nhập email khác cho lời mời này'
  } : {
    dang: 'You\'re signed in as ',
    chan: 'The referral gift is only for an email with no account on dermalogica.com.vn. Signing in for the first time creates an account, so the email you\'re using already has one and can\'t receive this gift.',
    tieuDeBuoc: 'To get the gift:',
    buoc: ['Tap the button below to sign out — this invitation will reopen by itself.', 'Enter an email that has never been used to sign in or order on dermalogica.com.vn, then tap Sign up.', 'Place your first order with that same email. If you need to sign in, sign in with this email only.'],
    luuY: 'Before you tap Sign up, don\'t sign in with any email — not even a new one. Any email that has signed in becomes an account and can no longer receive the gift.',
    daNhan: 'This email is registered for the invitation — the gift applies to the first product order on this account.',
    chinhMinh: 'This is your own referral link — share it with friends so they can get the gift.',
    thoat: 'sign out to enter another email for this invitation'
  };
  function dangNhapHopB(goc) {
    if (!KH_DN || !goc || !goc.querySelectorAll) return;
    var hop = goc.querySelector ? goc.querySelector('#BLOY-referral__modal') : null;
    if (!hop || hop.querySelector('.eguru-dn')) return;
    var act = hop.querySelector('.BLOY-popup__referral_email_action');
    if (!act) return;                                  // BLOY đang ở bước khác (đã ghi nhận…) — để nguyên
    var doc = hop.ownerDocument;
    var gt = maGtDangMo();
    // 05/10 14:19: khách đã đăng ký ở hộp (thẻ gioi-thieu-khach) rồi đăng nhập bằng chính email đó → đã ghi nhận, không chặn
    var la = gt && gt === String(KH_DN.id) ? 'chinhMinh' : (KH_DN.gtKhach ? 'daNhan' : 'chan');
    var khoi = doc.createElement('div');
    khoi.className = 'eguru-dn eguru-dn--' + la;
    if (la !== 'chinhMinh' && KH_DN.email) {
      var p1 = doc.createElement('p'); p1.className = 'eguru-dn-ai';
      p1.appendChild(doc.createTextNode(CHU_DN.dang));
      var b = doc.createElement('strong'); b.textContent = KH_DN.email; p1.appendChild(b);
      p1.appendChild(doc.createTextNode('.'));
      khoi.appendChild(p1);
    }
    var p2 = doc.createElement('p'); p2.className = 'eguru-dn-chu'; p2.textContent = CHU_DN[la];
    khoi.appendChild(p2);
    if (la === 'chan') {
      // 05/10 14:04 anh Thắng: nói rõ từng bước — đăng xuất, nhập email khác vào CHÍNH lời mời này, đừng đăng nhập trước
      var p3 = doc.createElement('p'); p3.className = 'eguru-dn-buoc-tieu-de'; p3.textContent = CHU_DN.tieuDeBuoc;
      khoi.appendChild(p3);
      var ol = doc.createElement('ol'); ol.className = 'eguru-dn-buoc';
      CHU_DN.buoc.forEach(function (t) { var li = doc.createElement('li'); li.textContent = t; ol.appendChild(li); });
      khoi.appendChild(ol);
      // 05/10 14:19 anh Thắng "lỡ họ login mail khác thì sao": đăng nhập bằng email nào cũng tự tạo tài khoản
      var p4 = doc.createElement('p'); p4.className = 'eguru-dn-luu-y'; p4.textContent = CHU_DN.luuY;
      khoi.appendChild(p4);
      var a = doc.createElement('a');
      a.className = 'eguru-dn-thoat';
      a.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'account/logout';
      a.textContent = CHU_DN.thoat;
      a.addEventListener('click', function () {
        // gioi-thieu-ban-be.js đọc khoá này ở trang đầu sau khi đăng xuất → mở lại đúng link mời (hộp hiện lại, nhập email mới)
        try { sessionStorage.setItem('gt_mo_lai', JSON.stringify({ duong: location.pathname + location.search, ts: Date.now() })); } catch (e) {}
      });
      khoi.appendChild(a);
    }
    dangGhi = true;
    hop.classList.add('eguru-co-dn');
    act.parentNode.insertBefore(khoi, act);
    dangGhi = false;
  }

  /* 05/10 13:45 (anh Thắng: "ghi rõ từng case… email đã được đăng ký tại hệ thống, email đã dùng rồi hay email sai định
     dạng"). BLOY chỉ có MỘT câu "Bạn không đủ điều kiện nhận quà này" cho mọi lỗi — đo 05/10: sai định dạng thì BLOY không
     gửi đi; email đã có tài khoản và email đã đăng ký nhận lời mời trước đó cùng trả 400 Bad Request (lần đăng ký đầu BLOY
     tự tạo tài khoản cho email, nên hai ca này KHÔNG tách được nếu không có máy chủ tra email — không dựng hạ tầng ngầm).
     Theme: (1) kiểm trống / sai định dạng TRƯỚC khi BLOY gửi, báo đúng lỗi, chặn lượt gửi; (2) BLOY từ chối email hợp lệ →
     nếu chính trình duyệt này đã đăng ký email đó (localStorage gt_ref_da_gui do gioi-thieu-ban-be.js ghi khi đăng ký
     thành công) thì báo "đã ghi nhận, chỉ cần đặt hàng"; ngược lại báo "đã có trong hệ thống" kèm 2 khả năng + cách xử lý.
     Có câu rõ thì giấu câu chung của BLOY (lớp eguru-co-loi, custom-third-party.css). */
  var LOI_DK = laVi ? {
    trong: 'Bạn chưa nhập email.',
    dinhDang: 'Email chưa đúng định dạng — kiểm tra lại từng ký tự, ví dụ: ten@gmail.com.',
    daGhiNhan: 'Email này đã được ghi nhận lời mời trên trình duyệt này — không cần đăng ký lại, bạn chỉ cần đặt đơn đầu tiên bằng đúng email này.',
    coTrongHeThong: 'Email này đã có trong hệ thống Dermalogica:',
    kn1: 'Nếu bạn đã đăng ký nhận lời mời bằng email này trước đó (ở máy khác): lời mời vẫn được giữ — chỉ cần đặt đơn đầu tiên bằng đúng email này.',
    kn2: 'Nếu email này đã có tài khoản trên dermalogica.com.vn (từng đăng nhập, đăng ký hoặc mua hàng): quà giới thiệu chỉ dành cho email chưa có tài khoản nên không áp dụng — bạn có thể dùng một email khác chưa từng đăng ký.'
  } : {
    trong: 'Please enter your email.',
    dinhDang: 'This email doesn\u2019t look right — please check each character, e.g. name@gmail.com.',
    daGhiNhan: 'This email is already registered for the invitation in this browser — no need to sign up again, just place your first order with this email.',
    coTrongHeThong: 'This email is already in the Dermalogica system:',
    kn1: 'If you signed up for the invitation with this email before (on another device): it is still kept — just place your first order with this email.',
    kn2: 'If this email already has an account on dermalogica.com.vn (signed in, registered or ordered before): the referral gift is only for an email with no account, so it does not apply — you can use another email that has never been registered.'
  };
  var MAU_EMAIL = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/;
  var emailVuaGui = '';
  function xoaLoiDk(hop) {
    if (!hop) return;
    var cu = hop.querySelector('.eguru-loi');
    dangGhi = true;
    if (cu) cu.parentNode.removeChild(cu);
    hop.classList.remove('eguru-co-loi');
    dangGhi = false;
  }
  function hienLoiDk(hop, loai) {
    var act = hop && hop.querySelector('.BLOY-popup__referral_email_action');
    if (!act) return;
    xoaLoiDk(hop);
    var d = hop.ownerDocument;
    var k = d.createElement('div');
    k.className = 'eguru-loi eguru-loi--' + loai;
    k.setAttribute('role', 'alert');
    var p1 = d.createElement('p'); p1.textContent = LOI_DK[loai]; k.appendChild(p1);
    if (loai === 'coTrongHeThong') {
      var ul = d.createElement('ul');
      ['kn1', 'kn2'].forEach(function (x) { var li = d.createElement('li'); li.textContent = LOI_DK[x]; ul.appendChild(li); });
      k.appendChild(ul);
    }
    var o = act.querySelector('.BLOY-popup__referral_email_input_wrapper');
    dangGhi = true;
    hop.classList.add('eguru-co-loi');
    if (o && o.nextSibling) act.insertBefore(k, o.nextSibling); else act.appendChild(k);
    dangGhi = false;
  }
  function kiemTruocKhiGui(e, hop) {
    var o = hop.querySelector('input.BLOY-popup__referral_email_input');
    var v = o ? String(o.value || '').trim() : '';
    var loai = !v ? 'trong' : (!MAU_EMAIL.test(v) ? 'dinhDang' : '');
    if (loai) {
      e.preventDefault(); e.stopImmediatePropagation();      // không để BLOY gửi + hiện câu chung
      hienLoiDk(hop, loai);
      if (o) o.focus();
      return;
    }
    xoaLoiDk(hop);
    emailVuaGui = v.toLowerCase();
  }
  if (!KH_DN) {
    document.addEventListener('click', function (e) {
      var nut = e.target && e.target.closest ? e.target.closest('#BLOY-referral__modal .BLOY-popup__referral_email_action button') : null;
      if (nut) kiemTruocKhiGui(e, nut.closest('#BLOY-referral__modal'));
    }, true);
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var o = e.target && e.target.closest ? e.target.closest('#BLOY-referral__modal input.BLOY-popup__referral_email_input') : null;
      if (o) kiemTruocKhiGui(e, o.closest('#BLOY-referral__modal'));
    }, true);
    document.addEventListener('input', function (e) {
      var o = e.target && e.target.closest ? e.target.closest('#BLOY-referral__modal input.BLOY-popup__referral_email_input') : null;
      if (o) xoaLoiDk(o.closest('#BLOY-referral__modal'));
    }, true);
  }
  // gọi từ nhacDieuKien mỗi lần BLOY vẽ lại: BLOY từ chối một email HỢP LỆ → thay câu chung bằng câu rõ
  function goiYTuChoi(goc) {
    if (KH_DN || !goc || !goc.querySelector) return;
    var hop = goc.querySelector('#BLOY-referral__modal');
    if (!hop || !emailVuaGui || hop.querySelector('.eguru-loi')) return;
    var loiBloy = hop.querySelector('.BLOY-popup__referral_error');
    if (!loiBloy || !/không đủ điều kiện|not eligible/i.test(loiBloy.textContent || '')) return;
    var da = null;
    try { da = JSON.parse(localStorage.getItem('gt_ref_da_gui') || 'null'); } catch (e) {}
    hienLoiDk(hop, da && da.email === emailVuaGui ? 'daGhiNhan' : 'coTrongHeThong');
  }

  var MAU_DEM_GIOI_THIEU = /^(Đã giới thiệu thành công|)\s*(\d+)\s*(người|referrals? completed)$/i;
  var CHU_DU_3 = 'Từ lượt 3, mỗi lượt có một voucher dịch vụ 20% — voucher đang được chuẩn bị.';
  var CHU_DU_3_CO_MA = 'Từ lượt 3, mỗi lượt có một voucher dịch vụ 20%, gửi qua email của bạn.';   // Flow D tự cấp mã, mỗi lượt từ lượt 3
  /* 23/09/2026 — ô gioi_thieu.voucher đổi thành DANH SÁCH nhiều mã: chị Linh chốt 19:18 là từ lượt
     giới thiệu thứ 3 trở đi thì MỖI lượt một voucher 20%, không dừng ở lượt 3 như hiểu trước đây.
     Định dạng website-theme ghi: "mã:trị giá:hạn" ngăn nhau bằng dấu "|", không có thì ghi "-".
     Hàm này chỉ lấy phần mã; vẫn đọc được ô kiểu cũ chỉ có một mã trơn. */
  function homNaySo() {
    var d = new Date();                       /* ngày MÁY KHÁCH, không dùng toISOString kẻo lệch múi giờ */
    return d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();
  }
  function dsMaVoucher(gt) {
    var ra = [];
    if (!gt) return ra;
    var nay = homNaySo();
    var phan = String(gt).split('|');
    for (var i = 0; i < phan.length; i++) {
      var o = phan[i].split(':');
      var ma = (o[0] || '').trim();
      if (!ma || ma === '-') continue;
      /* phần thứ ba là HẠN dạng dd/mm/yyyy — mã quá hạn thì bỏ, kẻo khách mang tới salon rồi bị từ chối.
         Dữ liệu cũ chỉ có mã trơn (không có hạn) thì vẫn giữ. */
      var h = (o[2] || '').trim();
      if (h) {
        var n = h.split('/');
        if (n.length === 3) {
          var han = (+n[2]) * 10000 + (+n[1]) * 100 + (+n[0]);
          if (han && han < nay) continue;
        }
      }
      ra.push(ma);
    }
    return ra;
  }

  function khoaBaLuot(goc) {
    if (!goc || !goc.querySelectorAll) return;
    var ds = goc.querySelectorAll('.BLOY-popup__referral_completed_count, .BLOY-popup__header--title-second');
    for (var i = 0; i < ds.length; i++) {
      var el = ds[i];
      var chu = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (el.getAttribute('data-eguru-dem') === chu) continue;    // đã ghi đúng chữ này rồi
      var m = chu.match(MAU_DEM_GIOI_THIEU);
      if (!m) continue;
      /* 28/09/2026 — BỎ TRẦN 3: từ lượt 3 mỗi lượt đều có voucher, chương trình không giới hạn số lượt,
         nên hiện đúng số lượt (trước đây "N/3", N>3 vẫn "3/3"). */
      var n = Math.max(parseInt(m[2], 10) || 0, 0);
      // 17/09 10:30 phương án C: số lượt lấy từ metafield gioi_thieu.so_luot do Flow ghi (đơn huỷ tự trừ), không lấy số
      // BLOY đếm (BLOY tính lúc đăng ký email, huỷ không lùi). Đổ vào window.eguruKhach ở layout/theme.liquid.
      if (KHACH) n = Math.max(parseInt(KHACH.soLuot, 10) || 0, 0);
      var laAnh = /referral/i.test(m[3]);
      var chuMoi = laAnh ? (n + (n === 1 ? ' referral completed' : ' referrals completed')) : ('Đã giới thiệu thành công ' + n + ' người');
      dangGhi = true;
      ghiChu(el, chuMoi);   // 18/09: ghiChu, không thay node
      el.setAttribute('data-eguru-dem', chuMoi);
      if (el.classList.contains('BLOY-popup__referral_completed_count')) {
        var ke = el.nextElementSibling;
        if (n >= 3 && (!ke || !ke.classList.contains('eguru-du-3'))) {
          ke = el.ownerDocument.createElement('div');
          ke.className = 'eguru-du-3';
          ke.textContent = (KHACH && dsMaVoucher(KHACH.voucher).length) ? CHU_DU_3_CO_MA : CHU_DU_3;
          el.parentNode.insertBefore(ke, el.nextSibling);
        }
        // mã voucher 20% (metafield gioi_thieu.voucher — từ 23/09 là DANH SÁCH nhiều mã) — hiện ngay dưới dòng đếm
        var ma = KHACH ? dsMaVoucher(KHACH.voucher).join(', ') : '';
        if (ma && !el.parentNode.querySelector('.eguru-voucher')) {
          var v = el.ownerDocument.createElement('div');
          v.className = 'eguru-voucher';
          v.textContent = 'Mã voucher của bạn: ' + ma;
          var sau = el.nextElementSibling && el.nextElementSibling.classList.contains('eguru-du-3') ? el.nextElementSibling : el;
          sau.parentNode.insertBefore(v, sau.nextSibling);
        }
      }
      dangGhi = false;
    }
  }

  function chiaMoc(goc) {
    if (!goc || !goc.querySelectorAll) return;
    var ds = goc.querySelectorAll('.BLOY-popup__referral_reward_value, #BLOY-referral__modal .BLOY-popup__point-item span');
    for (var i = 0; i < ds.length; i++) {
      var el = ds[i];
      if (el.querySelector('.eguru-moc')) continue;
      var chu = (el.textContent || '').replace(/\s+/g, ' ').trim();
      var cau = MOC[chu];
      if (!cau && el.matches && el.matches(CHON_BAN_NHAN)) cau = MOC_BAN_NHAN;
      if (!cau) continue;
      var html = '';
      if (cau.mo) html += '<span class="eguru-moc-mo">' + cau.mo + '</span>';
      for (var k = 0; k < cau.dong.length; k++) html += '<span class="eguru-moc"><span class="eguru-tick" aria-hidden="true">✓</span><span class="eguru-moc-chu">' + cau.dong[k] + '</span></span>';
      dangGhi = true;
      el.innerHTML = html;
      dangGhi = false;
    }
  }

  /* --- tráo chữ bên trong iframe của popup --- */
  var daCanhIframe = false;
  var docDaCanh = null;   // document iframe đang được observer canh (18/09)

  function traoIframe() {
    if (!canTrao || !popup) return;
    var f = popup.querySelector('iframe');
    var d;
    try {
      d = f && f.contentDocument;
    } catch (e) {
      return; // khác gốc thì chịu, nhưng đo 08/09 thì cùng gốc
    }
    if (!d || !d.body) return;
    giauThuong(d);
    chiaMoc(d.body);
    suaHangGioiThieu(d.body);
    khoaBaLuot(d.body);
    ganMaGioiThieu(d);
    nhacDieuKien(d.body);
    traoTrong(d.body);
    chiRefer(d);
    khopCao(d);

    // 18/09 13:10 — canh theo TỪNG document: BLOY có lúc dựng lại document trong iframe (sau khi tải dữ liệu / đăng nhập)
    // → observer gắn vào body cũ chết lặng, chỉ còn soiDon (1,5 s sau mỗi cú bấm) chạy lại; đo 18/09 thấy khung dính ở
    // chiều cao lúc đang tải (302/561px) vì ruột đổi sau đó mà không ai đo lại. Document mới thì gắn observer mới.
    if (docDaCanh === d) return;
    docDaCanh = d;
    // Bấm sang màn con là BLOY dựng lại ruột — phải tráo lại.
    new MutationObserver(function () {
      if (dangGhi) return;
      giauThuong(d);
      chiaMoc(d.body);
      suaHangGioiThieu(d.body);
      khoaBaLuot(d.body);
      ganMaGioiThieu(d);
      nhacDieuKien(d.body);
      traoTrong(d.body);
      chiRefer(d);
      khopCao(d);
    }).observe(d.body, { childList: true, subtree: true, characterData: true });
    if (daCanhIframe) return;   // các listener cửa sổ dưới đây chỉ gắn một lần
    daCanhIframe = true;
    // 17/09 00:30 — đổi cỡ cửa sổ / xoay máy: chờ 150ms rồi tính lại, lấy document iframe MỚI mỗi lần
    // (BLOY có thể dựng lại iframe sau đăng nhập → tham chiếu d cũ chết).
    var khopCaoCho = 0;
    function khopCaoLai() {
      clearTimeout(khopCaoCho);
      khopCaoCho = setTimeout(function () {
        var f2 = popup && popup.querySelector('iframe');
        var d2 = null;
        try { d2 = f2 && f2.contentDocument; } catch (e) { return; }
        if (d2) khopCao(d2);
      }, 150);
    }
    window.addEventListener('resize', khopCaoLai);
    window.addEventListener('orientationchange', khopCaoLai);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', khopCaoLai);
  }

  function gan(el) {
    popup = el;
    soi();
    traoIframe();
    ['transitionrun', 'transitionend', 'transitioncancel'].forEach(function (ev) {
      popup.addEventListener(ev, soi);
    });
    var goc = document.querySelector('.BLOY-root') || document.body;
    goc.addEventListener('click', soiDon, true);
    // Chữ trên chính cái nút cũng cần tráo.
    chiaMoc(goc);
    nhacDieuKien(goc);
    doiTenNut(goc);
    traoTrong(goc);
    // 16/09 — popup B (#BLOY-referral__modal) BLOY vẽ thẳng vào .BLOY-root SAU lúc này
    // (khách mở link ?bloy_ref rồi nhập email) → canh .BLOY-root để tách mốc + tráo chữ.
    new MutationObserver(function () {
      if (dangGhi) return;
      chiaMoc(goc);
      nhacDieuKien(goc);
      doiTenNut(goc);
      traoTrong(goc);
    }).observe(goc, { childList: true, subtree: true, characterData: true });
  }

  function tim() {
    var el = document.querySelector('.BLOY-popup');
    if (!el) return false;
    gan(el);
    return true;
  }

  if (tim()) return;

  // Chưa có thì đợi BLOY chèn vào. Ngưng sau 30 giây để khỏi để lại observer
  // chạy suốt đời trang khi app không được bật.
  var doi = new MutationObserver(function () {
    if (tim()) doi.disconnect();
  });
  doi.observe(document.body, { childList: true, subtree: true });
  window.setTimeout(function () {
    doi.disconnect();
  }, 30000);
})();

/**
 * THU GỌN NÚT ĐIỂM THƯỞNG THÀNH HÌNH TRÒN — TỰ ĐỘNG THEO CUỘN
 * eGURU 08/09/2026, làm lại 11/09/2026.
 *
 * Bản 08/09 gắn một chốt « » ở góc trên phải viên nút để khách tự bấm thu gọn,
 * nhớ qua localStorage. Anh Thắng 11/09: "bỏ đi nút góc trên phải đi vì tôi
 * thấy không cần thiết, thu hẹp có thể tùy biến kiểu khác cho gọn không".
 *
 * KIỂU MỚI, không cần khách làm gì:
 *   - Đầu trang (chưa cuộn quá 160px): viên nút đầy đủ, logo "d" + "Điểm thưởng"
 *     để khách biết nó là gì.
 *   - Cuộn xuống đọc nội dung: <html> nhận lớp `bloy-thu-gon`, CSS co viên
 *     thành hình tròn 60px chỉ còn logo — che ít nội dung nhất (giống bong bóng
 *     Zalo ở góc phải).
 *   - Rê chuột / focus bàn phím vào hình tròn thì nó nở ra lại thành viên đủ
 *     chữ (CSS :hover/:focus-visible ở custom-third-party.css). Điện thoại không
 *     có hover thì cứ hình tròn — bấm vẫn mở popup như thường.
 *   - Cuộn về đầu trang thì nở ra lại.
 *
 * Không còn localStorage: trạng thái suy từ vị trí cuộn, trang nào cũng đúng.
 * Mở popup (lớp bloy-dang-mo) thì logo đổi thành X — vẫn dùng chung, không đụng.
 */
(function () {
  'use strict';

  var LOP = 'bloy-thu-gon';
  var NGUONG = 160;
  var goc = document.documentElement;
  var dangCho = false;

  function capNhat() {
    dangCho = false;
    var y = window.pageYOffset || goc.scrollTop || 0;
    goc.classList.toggle(LOP, y > NGUONG);
  }

  function khiCuon() {
    if (dangCho) return;
    dangCho = true;
    window.requestAnimationFrame(capNhat);
  }

  capNhat();
  window.addEventListener('scroll', khiCuon, { passive: true });
})();

/* 28/09 (anh Thang duyet 20:58) — Khach DANG NHAP tu thanh thanh vien BLOY (BLOY van giu "Customers must sign up before earning points").
   Hop BLOY bi an (Derma chot), nen theme tu goi ham "Tham gia" cua goi popup BLOY mot lan cho moi khach.
   Khach vang lai khong co BloyUser.id nen bo qua; khach dai ly (the bi loai trong BLOY) bo qua.
   Ham nam trong goi webpack cua BLOY (tim theo chu "requestExplicitJoin"): BLOY doi goi thi co the khong tim thay
   -> chi canh bao console, trang khong loi. Kiem lai sau moi lan BLOY len ban moi.
   Khach chi duoc tu tham gia khi mo it nhat mot trang cua cua hang luc da dang nhap. */
(function () {
  var U = window.BloyUser;
  if (!U || !U.id || !U.token) return;
  var loai = (window.BloyConfigs && window.BloyConfigs.excludeCustomerTags) || [];
  if ((U.tags || []).some(function (t) { return loai.indexOf(t) > -1; })) return;
  // 12/10 (ra soat): dai ly moi Derma tao tay chua gan the hang si van la tai khoan cong ty B2B -> khong tu vao BLOY.
  // Co daiLy tinh o layout/theme.liquid (window.eguruKhach) bang customer.company_available_locations.
  if (window.eguruKhach && window.eguruKhach.daiLy) return;
  var KHOA = 'eguru_bloy_da_tham_gia_' + U.id;
  try { if (localStorage.getItem(KHOA)) return; } catch (e) {}
  // 02/10 (anh Thang chot, QC #13): khach CHUA co the BLOYtier_* luc tai trang = chua tung vao BLOY -> tham gia lan dau.
  // Tham gia thanh cong thi ban 1 su kien Klaviyo "TV0 - Chao mung thanh vien" (khoa cong khai, nhu dong bo ngay sinh / gioi thieu);
  // luong Klaviyo gui 1 thu chao mung, loc "chua tung vao luong". Khach cu doi may da co the hang nen khong ban lai.
  var LAN_DAU = !(U.tags || []).some(function (t) { return String(t).indexOf('BLOYtier_') === 0; });
  function chaoMung() {
    if (!LAN_DAU || !U.email) return;
    var KHOA_TV0 = 'eguru_tv0_da_ban_' + U.id;
    try { if (localStorage.getItem(KHOA_TV0)) return; } catch (e) {}
    var en = /^\/en(\/|$)/.test(location.pathname);
    fetch('https://a.klaviyo.com/client/events/?company_id=Rvg2GF', {
      method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' }, keepalive: true,
      body: JSON.stringify({ data: { type: 'event', attributes: {
        properties: { nguon: 'theme-tu-tham-gia', ngon_ngu: en ? 'en' : 'vi' },
        metric: { data: { type: 'metric', attributes: { name: 'TV0 - Chao mung thanh vien' } } },
        profile: { data: { type: 'profile', attributes: { email: U.email, first_name: U.first_name || undefined } } }
      } } })
    }).then(function (r) { if (r.status === 202) { try { localStorage.setItem(KHOA_TV0, '1'); } catch (e) {} } }).catch(function () {});
  }
  var lan = 0, dh = setInterval(function () {
    var q = window.webpackChunkbloy_extensions;
    if (!q || q.push === Array.prototype.push) { if (++lan > 60) { clearInterval(dh); console.warn('[eguru] BLOY chua nap, bo qua tu tham gia'); } return; }
    clearInterval(dh);
    try {
      var req; q.push([['eguru_join_' + Date.now()], {}, function (r) { req = r; }]);
      if (!req || !req.m) { console.warn('[eguru] khong lay duoc require cua BLOY'); return; }
      var id = Object.keys(req.m).find(function (k) { return String(req.m[k]).indexOf('requestExplicitJoin') > -1; });
      if (!id) { console.warn('[eguru] khong tim thay ham tham gia BLOY'); return; }
      var mod = req(id);
      var fn = Object.keys(mod).map(function (k) { return mod[k]; })
        .find(function (f) { return typeof f === 'function' && String(f).indexOf('requestExplicitJoin') > -1; });
      if (!fn) { console.warn('[eguru] khong tim thay ham tham gia BLOY'); return; }
      Promise.resolve(fn()).then(function (ok) { if (ok) { try { localStorage.setItem(KHOA, '1'); } catch (e) {} chaoMung(); } });
    } catch (e) { console.warn('[eguru] tu tham gia BLOY loi', e); }
  }, 500);
})();

